<template>
  <div class="test-view may-18-test user-select-none">
    <div v-if="isOnline">
      <div
        :class="
          isPreview && isTestCustom && isOnlineTest
            ? 'test-page-section new-cp-5dec'
            : !isOnlineTest || !isTestCustom
            ? 'test-page-section new-cp-5dec-mobile'
            : 'test-page-section '
        "
        ref="testView"
      >
        <div class="test-btn-quection">
          <div class="test-info-block">
            <div
              class="ts-info order-ts-1"
              v-if="user && studentResponse == user.role_code"
            >
              <span v-if="user && studentResponse == user.role_code"
                >Consolidated Response</span
              >
              <v-tooltip bottom content-class="question-tooltip">
                <template v-slot:activator="{ on }">
                  <v-icon class="info-alert" v-on="on" @mouseover="getLegendsData(null)"
                    >mdi-alert-circle</v-icon
                  >
                </template>
                <LegendsOnHover :legendsCount="legendsData" :isPreview="isPreview" />
              </v-tooltip>
            </div>
            <div class="ts-info order-ts-1" v-else>
              <span>Paper Coverage</span>
              <v-tooltip bottom dark content-class="click-here">
                <template v-slot:activator="{ on }">
                  <v-icon class="info-alert" @click="onPaperCoverage" v-on="on"
                    >mdi-alert-circle</v-icon
                  >
                </template>
                <span>Click Here</span>
              </v-tooltip>
            </div>
            <div class="vertical-line"></div>
            <div class="ts-info order-ts-2">
              <span>Question Paper</span>
              <v-tooltip bottom dark content-class="click-here">
                <template v-slot:activator="{ on }">
                  <v-icon class="info-alert" @click="showAllQuestions" v-on="on"
                    >mdi-alert-circle</v-icon
                  >
                </template>
                <span>Click Here</span>
              </v-tooltip>
            </div>
            <div class="vertical-line" v-if="shouldShowVerticalLine"></div>

            <div class="ts-info order-ts-3" v-if="!isStudent || (isStudent && hasInstructions)">
              <span>{{ instructionsText }}</span>
              <v-tooltip bottom dark content-class="click-here">
                <template v-slot:activator="{ on }">
                  <v-icon
                    class="info-alert"
                    v-on="on"
                    @click=" hasInstructions?showInstructions():editInstruction()"
                  >{{ iconType }}</v-icon>
                </template>
                <span>Click Here</span>
              </v-tooltip>
            </div>          </div>
          <div
            :class="
              isPreview && isTestCustom && isOnlineTest
                ? 'slide-btn-group cust-slide cp3-5dec'
                : !isOnlineTest || !isTestCustom
                ? 'slide-btn-group cust-slide cp3-5dec-mobile'
                : 'slide-btn-group cust-slide '
            "
          >
            <v-row>
              <v-col cols="1" sm="1" class="pad-zero-top-bottom">
                <div
                  v-if="$refs && $refs.carousel && $refs.carousel.canAdvanceBackward"
                  class="center-arrow1"
                >
                  <v-icon
                    @click.prevent="gotoDirection(true, 'backward')"
                    class="info-alert"
                    >mdi-chevron-double-left</v-icon
                  >
                  <v-icon
                    @click.prevent="gotoDirection(false, 'backward')"
                    class="info-alert"
                    >mdi-chevron-left</v-icon
                  >
                </div>
              </v-col>
              <v-col cols="10" sm="10" class="pad-zero-top-bottom">
                <carousel
                  ref="carousel"
                  :navigateTo="navigateTo"
                  :scrollPerPage="scrollPerPage"
                  :paginationEnabled="false"
                  :mouseDrag="false"
                  :perPageCustom="perPageCustom"
                >
                  <slide
                    v-for="(type, idx) in subjectQuestionTypeList"
                    :key="idx"
                    v-if="type.showSQT"
                  >
                    <v-btn
                      class="btn-default carousel-btn"
                      :class="{
                        ' active ': idx == selectedSQTIndex,
                        'disabled-field': disableSecondaryAction,
                      }"
                      depressed
                      width="95%"
                      :disabled="isEditing || disableSecondaryAction"
                      :title="type.name"
                      @click="changeSubjectQuestionType(type, idx, 'JUMP')"
                    >
                      <span class="carousel-typename">{{ type.shortName }}</span>
                      <v-tooltip bottom dark content-class="question-tooltip">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            class="info-alert"
                            v-on="on"
                            @mouseover="getLegendsData(idx)"
                            >mdi-alert-circle</v-icon
                          >
                        </template>
                        <LegendsOnHover
                          :legendsCount="legendsData"
                          :isPreview="isPreview"
                        />
                      </v-tooltip>
                    </v-btn>
                  </slide>
                </carousel>
              </v-col>
              <v-col cols="1" sm="1" class="pad-zero-top-bottom">
                <div
                  v-if="$refs && $refs.carousel && $refs.carousel.canAdvanceForward"
                  class="center-arrow2"
                >
                  <v-icon
                    @click.prevent="gotoDirection(false, 'forward')"
                    class="info-alert"
                    >mdi-chevron-right</v-icon
                  >
                  <v-icon
                    @click.prevent="gotoDirection(true, 'forward')"
                    class="info-alert"
                    >mdi-chevron-double-right</v-icon
                  >
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- accordian -->
          <div class="test-counter-block test-couter-cp3 show-mobile-panel">
            <div v-if="isTestCustom || !isPreview" class="test-time-count">
              <div class="time-remaining-title">
                <v-btn
                  v-if="isPreview && isTestCustom"
                  @click="similarQuestionsPopup"
                  class="question-bucket right-align"
                  :class="{
                    active:
                      !isSearchAnotherQ &&
                      !isUploadAndReplace &&
                      currentQuestion.institute_id === null &&
                      !isEditable,
                  }"
                  ><div>
                    <div class="Bucket-que">Show All</div>
                    <div class="Bucket-select">Questions of Same Topic</div>
                  </div></v-btn
                >
                <div v-else-if="showTimer && !isPreview">
                  Time Remaining
                  <h4 v-show="showTimer">
                    {{ this.timeRemainingString }}
                  </h4>
                </div>
              </div>
              <div class="time-remaining-count">&nbsp;</div>
            </div>
          </div>
          <v-expansion-panels
            class="show-mobile-panel"
            :disabled="disableSecondaryAction"
            v-model="expansionPanelStatus"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div class="expansion-title mini-question-palette">
                  Question Palette
                  <MiniQuestionPallet
                    v-if="questionData"
                    :isPastTest="isPastTest"
                    :isPreview="isPreview"
                    :questionData="questionData"
                  />
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="test-counter-block test-couter-cp3">
                  <!-- <div class="test-time-count">
                    <div class="time-remaining-title">
                      <v-btn
                        color="primary"
                        v-if="isPreview && isTestCustom"
                        @click="editQuestion"
                        class="cust-btn right-align"
                        >{{ isEditing ? "Done" : "Edit" }}</v-btn
                      >
                      <div v-else-if="!hideTimer || showTimer">
                        Time Remaining
                        <h4 v-if="!hideTimer" v-show="showTimer">
                          {{ this.timeRemainingString }}
                        </h4>
                      </div>
                    </div>
                    <div class="time-remaining-count">
                      &nbsp;
                    </div>
                  </div> -->
                  <div class="inner-block">
                    <div class="number-contet">
                      <LegendsPreview
                        v-if="questionData"
                        :questionStatus="questionStatus"
                        :isPreview="isPreview"
                        :questions="questionData.questions"
                      />
                      <div class="hr-div"></div>
                      <QuestionPallet
                        v-if="questionData"
                        @jumpToQuestion="jumpToQuestion"
                        :isEditing="isEditing"
                        :isPreview="isPreview"
                        :isPastTest="isPastTest"
                        :isCustom="isTestCustom"
                        :questionData="questionData"
                      />
                    </div>
                    <div class="test-foter-blk">
                      <div
                        class="test-btn-block-ans"
                        :class="isPreview ? ' smallFont ' : ''"
                      >
                        <div class="marking marking-bold">
                          {{
                            questionData &&
                            questionData.mandatoryQuestions &&
                            (questionData.mandatoryQuestions.allow_all === 1 ||
                              questionData.mandatoryQuestions.allow_all === 0)
                              ? `Out of the ${questionData.questions.length} Questions ${questionData.mandatoryQuestions.mandatory_questions} are Mandatory`
                              : "All Questions in this section are Mandatory"
                          }}
                        </div>
                        <div class="marking">
                          {{
                            questionData && questionData.mandatoryQuestions
                              ? questionData.mandatoryQuestions.allow_all === 1
                                ? `You can answer all questions but the best  ${questionData.mandatoryQuestions.mandatory_questions} shall be evaluated`
                                : `You can only answer the mandatory number of questions`
                              : ""
                          }}
                        </div>
                        <div class="marking marking-bold">
                          Marking Scheme for this section:
                        </div>
                        <div class="marking">
                          Correct Response:+
                          {{ currentQuestion.correct_marks }}
                        </div>
                        <div class="marking">
                          Incorrect Response:{{ currentQuestion.negative_marks }}
                        </div>
                        <div
                          class="marking"
                          v-if="isPreview && currentQuestion.partial_marking > 0"
                        >
                          <v-icon small color="success">mdi-checkbox-marked</v-icon>
                          Partial Marking:{{ currentQuestion.partial_marking }}
                        </div>
                        <div
                          v-if="isPreview && currentQuestion.partial_marking == 0"
                          class="marking markingElse"
                        >
                          <v-icon small color="success">mdi-checkbox-marked</v-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-card class="mx-auto normal-card live-test-hg" ref="testBlock">
            <pinch-zoom class="pinch-zoom" disableZoomControl="disable" :wheel="false">
              <div
                class="tst-quection-block directorpriviewtest click-upload-replace-outer"
                ref="questionBox"
              >
                <div v-if="questionData && questionTypes">
                  <div
                    v-if="isEditing || isUploadAndReplace"
                    :class="{
                      'without-upload-&-replace-height-control': !isUploadAndReplace,
                      'with-upload-&-replace-height-control': isUploadAndReplace,
                    }"
                  >
                    <div>
                      <div class="chapter-name-row click-upload-replace">
                        <div class="cha-Upload-row">
                          <div class="chapter-label cha-Upload-label-1">
                            Chapter Name
                            <span>*</span>
                          </div>
                          <div class="chapter-drop">
                            <v-select
                              v-model="slectedChapter"
                              @change="onSelectChapter"
                              :items="chapters"
                              hide-details
                              dense
                              outlined
                              ref="chapterName"
                              class="dropdown-fix-160"
                            ></v-select>
                          </div>

                          <div class="chapter-label cha-Upload-label-1" v-if="isDBTest">
                            Topic Name
                            <span>*</span>
                          </div>
                          <div v-if="isDBTest" class="chapter-drop">
                            <v-select
                              v-model="selectedTopic"
                              @change="onSelectedTopic"
                              :items="topics"
                              hide-details
                              dense
                              outlined
                              ref="chapterName"
                              class="dropdown-fix-160"
                            ></v-select>
                          </div>

                          <div v-if="isDBTest" class="chapter-label cha-Upload-label-1">
                            Level
                            <span>*</span>
                          </div>
                          <div v-if="isDBTest" class="chapter-drop">
                            <v-select
                              v-model="selectedDifficultyLevel"
                              @change="onselectedDifficulty"
                              :items="difficulty"
                              hide-details
                              dense
                              outlined
                              ref="chapterName"
                              class="dropdown-fix-160"
                            ></v-select>
                          </div>
                        </div>
                        <div class="cha-Upload-row" v-if="isDBTest">
                          <div class="chapter-label cha-Upload-label-1">
                            SubTopic
                            <span>*</span>
                          </div>
                          <div class="chapter-drop">
                            <v-select
                              v-model="selectedSubTopic"
                              @change="onSelectedSubTopic"
                              :items="subTopics"
                              hide-details
                              dense
                              outlined
                              ref="chapterName"
                              class="dropdown-fix-160"
                            ></v-select>
                          </div>

                          <div class="chapter-label cha-Upload-label-1">
                            Concept
                            <span>*</span>
                          </div>
                          <div class="chapter-drop">
                            <v-select
                              v-model="selectedConcept"
                              @change="onSelectedConcept"
                              :items="concepts"
                              hide-details
                              dense
                              outlined
                              ref="chapterName"
                              class="dropdown-fix-160"
                            ></v-select>
                          </div>

                          <div class="chapter-label cha-Upload-label-1">
                            Skillset
                            <span>*</span>
                          </div>
                          <div class="chapter-drop">
                            <v-select
                              v-model="selectedSkillSet"
                              :items="skillset"
                              @change="onselectedSkillset"
                              hide-details
                              dense
                              outlined
                              ref="chapterName"
                              class="dropdown-fix-160"
                            ></v-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="upload-replace-scrooalble">
                      <SingleAnsQue
                        :showNextButton="showNextButton"
                        :question="currentQuestionToBeEdited"
                        :isEditable="isEditable"
                        v-if="
                          currentQuestion.question_type == questionTypes.SINGLE_CORRECT ||
                          currentQuestion.question_type ==
                            questionTypes.SINGLE_CORRECT_SEC2 ||
                          currentQuestion.question_type == questionTypes.ASSERTION_REASON
                        "
                      />

                      <MultipleCorrect
                        :showNextButton="showNextButton"
                        :question="currentQuestionToBeEdited"
                        :isEditable="isEditable"
                        v-if="
                          currentQuestion.question_type == questionTypes.MULTIPLE_CORRECT
                        "
                      />
                      <Integer
                        :showNextButton="showNextButton"
                        :isEditable="isEditable"
                        :question="currentQuestionToBeEdited"
                        v-if="currentQuestion.question_type == questionTypes.INTEGER"
                      />
                      <Subjective
                        :showNextButton="showNextButton"
                        :isEditable="isEditable"
                        :question="currentQuestionToBeEdited"
                        v-if="
                          currentQuestion.question_type == questionTypes.SUBJECTIVE ||
                          currentQuestion.question_type == questionTypes.SUBJECTIVEINTEGER
                        "
                      />
                      <MatrixMatch
                        :showNextButton="showNextButton"
                        :isEditable="isEditable"
                        :question="currentQuestionToBeEdited"
                        v-if="currentQuestion.question_type == questionTypes.MATRIX_MATCH"
                      />
                      <MatrixMatchOption
                        :showNextButton="showNextButton"
                        :isEditable="isEditable"
                        :question="currentQuestionToBeEdited"
                        v-if="
                          currentQuestion.question_type ==
                          questionTypes.MATRIX_MATCH_OPTION
                        "
                      />
                      <Comprehensions
                        :showNextButton="showNextButton"
                        :isEditable="isEditable"
                        :question="currentQuestionToBeEdited"
                        v-if="
                          currentQuestion.question_type == questionTypes.COMPREHENSION
                        "
                      />
                      <TC
                        :showNextButton="showNextButton"
                        :isEditable="isEditable"
                        :question="currentQuestionToBeEdited"
                        v-if="currentQuestion.question_type == questionTypes.TC"
                      />
                    </div>
                  </div>
                  <div
                    :class="
                      $refs.previewName
                        ? $refs.previewName.offsetHeight > 52
                          ? 'preview-test-6feb'
                          : ''
                        : ''
                    "
                    v-else
                  >
                    <div
                      ref="previewName"
                      class="chapter-name-row print-name preview-test-dropdown-block test-preivew-1-feb"
                      :class="{
                        'with-dropdown': isSearchAnotherQ,
                      }"
                      v-if="isPreview"
                    >
                      <div class="chapter-name-outer-cp3">
                        <div class="chapter-name-row-cp3">
                          <div
                            class="chapter-label search-another-label"
                            v-if="!isSearchAnotherQ"
                          >
                            Chapter Name -
                          </div>

                          <div
                            class="chapter-drop search-another-drop"
                            v-if="!isSearchAnotherQ"
                          >
                            <v-tooltip
                              left
                              bottom
                              content-class="cust-new-tooltip-top open-top"
                            >
                              <template v-slot:activator="{ on }">
                                <div
                                  v-on="on"
                                  depressed
                                  :class="{
                                    'text-transform-none': true,
                                    'btn-center': true,
                                    'btn-default': true,
                                  }"
                                >
                                  {{ currentQuestion.chapterName }}
                                </div>
                              </template>
                              <span> {{ currentQuestion.chapterName }} </span>
                            </v-tooltip>
                          </div>
                          <div
                            v-if="
                              currentQuestion.topicName &&
                              !isSearchAnotherQ &&
                              this.isDBTest
                            "
                            class="chapter-label search-another-label-2"
                          >
                            Topic Name -
                          </div>
                          <div
                            class="chapter-drop search-another-drop"
                            v-if="
                              currentQuestion.topicName &&
                              !isSearchAnotherQ &&
                              this.isDBTest
                            "
                          >
                            <v-tooltip
                              left
                              bottom
                              content-class="cust-new-tooltip-top open-top"
                            >
                              <template v-slot:activator="{ on }">
                                <span
                                  v-on="on"
                                  depressed
                                  :class="{
                                    'text-transform-none': true,
                                    'btn-center': true,
                                    'btn-default': true,
                                  }"
                                  >{{ currentQuestion.topicName }}</span
                                >
                              </template>
                              <span> {{ currentQuestion.topicName }} </span>
                            </v-tooltip>
                          </div>
                          <div
                            class="chapter-label search-another-label-3"
                            v-if="
                              currentQuestion.difficultyName &&
                              !isSearchAnotherQ &&
                              this.isDBTest
                            "
                          >
                            Level -
                          </div>

                          <div
                            class="chapter-drop search-another-drop"
                            v-if="
                              currentQuestion.difficultyName &&
                              !isSearchAnotherQ &&
                              isDBTest
                            "
                          >
                            <v-tooltip
                              left
                              bottom
                              content-class="cust-new-tooltip-top search-another-drop-easy open-top"
                            >
                              <template v-slot:activator="{ on }">
                                <span
                                  v-on="on"
                                  depressed
                                  :class="{
                                    'text-transform-none': true,
                                    'btn-center': true,
                                    'btn-default': true,
                                  }"
                                  >{{ currentQuestion.difficultyName }}</span
                                >
                              </template>
                              <span> {{ currentQuestion.difficultyName }} </span>
                            </v-tooltip>
                          </div>
                          <div
                            class="chapter-name-row isSearchAnothe-chapter"
                            v-if="isSearchAnotherQ"
                          >
                            <div class="isSearchAnothe-chapter-col ch-margin-btn-10">
                              <div class="chapter-label">Chapter Name</div>
                              <div class="chapter-drop">
                                <v-select
                                  v-model="slectedChapter"
                                  @change="getTopics()"
                                  :items="chapters"
                                  hide-details
                                  dense
                                  outlined
                                  ref="chapterName"
                                  class="dropdown-fix-160"
                                ></v-select>
                              </div>

                              <div class="chapter-label chapter-label-2">Topic Name</div>
                              <div class="chapter-drop">
                                <v-select
                                  v-model="selectedTopic"
                                  @change="getSubTopics()"
                                  :items="topics"
                                  hide-details
                                  dense
                                  outlined
                                  ref="chapterName"
                                  class="dropdown-fix-160"
                                ></v-select>
                              </div>

                              <div class="chapter-label chapter-label-3">Level</div>
                              <div class="chapter-drop">
                                <v-select
                                  v-model="selectedDifficultyLevel"
                                  :items="difficulty"
                                  hide-details
                                  dense
                                  outlined
                                  ref="chapterName"
                                  class="dropdown-fix-160"
                                ></v-select>
                              </div>
                            </div>
                            <!-- <div class="isSearchAnothe-chapter-col">
                         <div class="chapter-label">
                          Subtopic
                     
                          <span>*</span>
                        </div>
                        <div class="chapter-drop ">
                          <v-select
                            v-model="selectedSubTopic"
                            :items="subTopics"
                            @change="getConcepts()"
                            hide-details
                            dense
                            outlined
                          
                            class="dropdown-fix-160"
                          ></v-select>
                        </div>

                        <div class="chapter-label chapter-label-2">
                          Concept
                          <span>*</span>
                        </div>
                        <div class="chapter-drop">
                          <v-select
                            v-model="selectedConcept"
                            :items="concepts"
                            hide-details
                            dense
                            outlined
                            ref="chapterName"
                            class="dropdown-fix-160"
                          ></v-select>
                        </div>

                        <div class="chapter-label chapter-label-3">
                          Skillset
                          <span>*</span>
                        </div>
                        <div class="chapter-drop">
                          <v-select
                           v-model="selectedSkillSet"
                           :items="skillset"
                            hide-details
                            dense
                            outlined
                            ref="chapterName"
                            class="dropdown-fix-160" 
                          ></v-select>
                        </div>
                        </div> -->
                          </div>
                        </div>

                        <!-- <div class="chapter-name-row-cp3" v-if="
                          currentQuestion.institute_id === null &&
                            !isSearchAnotherQ
                        ">
                       <div
                        class="chapter-label search-another-label"
                         v-if="
                          currentQuestion.institute_id === null &&
                            !isSearchAnotherQ
                        "
                      >
                        Subtopic -
                      </div>
                       <div
                        class="chapter-drop search-another-drop"
                        v-if="
                          currentQuestion.institute_id === null &&
                            !isSearchAnotherQ
                        "
                      >
                        
                        <v-tooltip left  bottom content-class="cust-new-tooltip-top open-top">
			                  <template  v-slot:activator="{ on }">
                                            
                          <span
                          v-on="on"
                          depressed
                              :class="{
                              'text-transform-none': true,
                              'btn-center': true,
                              'btn-default': true,
                          }"
											
											>{{ currentQuestion.subtopicName}}</span
											>                     
											
										</template>
										<span > {{ currentQuestion.subtopicName  }} </span>
										</v-tooltip>
                        
                      </div>
                       <div
                        class="chapter-label search-another-label-2"
                         v-if="
                          currentQuestion.institute_id === null &&
                            !isSearchAnotherQ
                        "
                      >
                        Concept -
                      </div>
                      <div
                        class="chapter-drop search-another-drop"
                        v-if="
                          currentQuestion.institute_id === null &&
                            !isSearchAnotherQ
                        "
                      >
                         <v-tooltip left  bottom content-class="cust-new-tooltip-top open-top">
			                  <template  v-slot:activator="{ on }">
                                            
                          <span
                          v-on="on"
                          depressed
                              :class="{
                              'text-transform-none': true,
                              'btn-center': true,
                              'btn-default': true,
                          }"
											
											>{{ currentQuestion.conceptName}}</span
											>                     
											
										</template>
										<span > {{ currentQuestion.conceptName  }} </span>
										</v-tooltip>
                      </div>
                       <div
                        class="chapter-label search-another-label-3"
                         v-if="
                          currentQuestion.institute_id === null &&
                            !isSearchAnotherQ
                        "
                      >
                        Skillset-
                        
                        
                      </div>
                     <div
                        class="chapter-drop search-another-drop"
                        v-if="
                          currentQuestion.institute_id === null &&
                            !isSearchAnotherQ
                        "
                      >
                       
                         <v-tooltip left  bottom content-class="cust-new-tooltip-top open-top">
			                  <template  v-slot:activator="{ on }">
                                            
                          <span
                          v-on="on"
                          depressed
                              :class="{
                              'text-transform-none': true,
                              'btn-center': true,
                              'btn-default': true,
                          }"
											
											>{{ currentQuestion.skillsetName}}</span
											>                     
											
										</template>
										<span > {{ currentQuestion.skillsetName  }} </span>
										</v-tooltip>
                      </div>
                  </div> -->
                      </div>
                      <div class="btn-search-another-question last-used">
                        <v-btn
                          class="pyq-title active"
                          v-if="
                            currentQuestion.tags &&
                            currentQuestion.tags.length &&
                            currentQuestion.tags.length > 1 &&
                            !showTags
                          "
                          @click="showTags = true"
                          >PYQ</v-btn
                        >
                        <div
                          class="jee-card-row"
                          v-if="
                            currentQuestion.tags &&
                            currentQuestion.tags.length &&
                            (currentQuestion.tags.length < 2 ||
                              (currentQuestion.tags.length > 1 && showTags))
                          "
                          v-for="tag in currentQuestion.tags"
                        >
                          <div class="jee-btn">{{ tag.tag }}</div>
                        </div>
                        
                        <v-btn
                          v-if="currentQuestion.show_extra_details"
                          class="current-question-info views-btn"
                        >
                          <span class="view-week">
                            <b>{{ currentQuestion.question_view_count || 0 }}</b> Views in
                            <br />
                            Last 2 Weeks</span
                          >
                        </v-btn>
                        <v-btn
                          v-if="currentQuestion.show_extra_details"
                          class="current-question-info last-created-btn"
                          :class="
                            currentQuestion && currentQuestion.last_created_at
                              ? ''
                              : 'remove-pointer'
                          "
                        >
                          <v-tooltip
                            v-if="currentQuestion && currentQuestion.last_created_at"
                            bottom
                            :close-delay="1000"
                            content-class="cust-new-tooltip-bottom search-another-drop-easy open-top"
                          >
                            <template v-slot:activator="{ on }">
                              <span
                                v-on="on"
                                depressed
                                :class="{
                                  'text-transform-none': true,
                                  'btn-center': true,
                                  'btn-default': true,
                                }"
                              >
                                <span class="last-info">Last Used </span>
                                <br />
                                <strong>
                                  {{
                                    currentQuestion.last_created_at
                                      ? currentQuestion.last_created_at
                                      : "NEVER"
                                  }}
                                </strong>
                              </span>
                            </template>
                            <span>
                              <div class="history-data-parent">
                                <div class="r-body">
                                  <div class="history-data">
                                    <span class="center-width"
                                      ><strong>Date </strong></span
                                    >
                                    <span>{{ currentQuestion.last_created_at }}</span>
                                  </div>
                                  <div
                                    class="history-data"
                                    v-if="
                                      currentQuestion &&
                                      currentQuestion.lastScheduledCenters
                                    "
                                  >
                                    <span class="center-width"
                                      ><strong>Centers </strong></span
                                    >
                                    <span>{{
                                      currentQuestion.lastScheduledCenters
                                    }}</span>
                                  </div>
                                  <div
                                    class="history-data"
                                    v-if="
                                      currentQuestion &&
                                      currentQuestion.lastScheduledBatches
                                    "
                                  >
                                    <span class="center-width"
                                      ><strong>Batches </strong></span
                                    >
                                    <span>{{
                                      currentQuestion.lastScheduledBatches
                                    }}</span>
                                  </div>
                                  <div class="history-data" v-else>Not Scheduled</div>
                                </div>
                              </div>
                            </span>
                          </v-tooltip>
                          <span v-else class="last-info"
                            >Last Used <br />
                            <strong>
                              {{
                                currentQuestion.last_created_at
                                  ? currentQuestion.last_created_at
                                  : "NEVER"
                              }}
                            </strong></span
                          >
                        </v-btn>
                        <v-btn
                          v-if="currentQuestion.show_extra_details"
                          class="current-question-info usage-details-btn"
                          @click="openHistoryDialog()"
                        >
                          <span class="view-week">Usage Details </span>
                        </v-btn>
                        <v-btn
                          v-if="isPreview && isTestCustom && this.isDBTest && !isAits"
                          color="primary"
                          :disabled="isEditable"
                          @click="searchAnotherQ()"
                          class="right-btn cust-btn"
                        >
                          {{ isSearchAnotherQ ? "Search Again" : "Search Another Q." }}
                        </v-btn>
                      </div>
                    </div>
                    <div
                      class="cp3privew-test-bk cp3-17-april"
                      :class="{
                        'without-search-height-control': !isSearchAnotherQ,
                        'with-search-height-control': isSearchAnotherQ,
                      }"
                    >
                      <Comprehension
                        :showAnswerField="questionData.showAnswerField"
                        :currentQuestion="currentQuestion"
                        :isPreview="isPreview"
                        v-if="
                          currentQuestion.question_type == questionTypes.COMPREHENSION ||
                          currentQuestion.question_type == questionTypes.TC
                        "
                      />
                      <SingleAnsQuePrivew
                        :showAnswerField="questionData.showAnswerField"
                        :currentQuestion="currentQuestion"
                        :openMandatoryQuePopup="openMandatoryQuePopup"
                        v-if="
                          currentQuestion.question_type == questionTypes.SINGLE_CORRECT ||
                          currentQuestion.question_type ==
                            questionTypes.SINGLE_CORRECT_SEC2 ||
                          currentQuestion.question_type == questionTypes.ASSERTION_REASON
                        "
                      />
                      <MultipleCorrectPrivew
                        :showAnswerField="questionData.showAnswerField"
                        :currentQuestion="currentQuestion"
                        :openMandatoryQuePopup="openMandatoryQuePopup"
                        v-if="
                          currentQuestion.question_type == questionTypes.MULTIPLE_CORRECT
                        "
                      />
                      <IntegerPrivew
                        :showAnswerField="questionData.showAnswerField"
                        :currentQuestion="currentQuestion"
                        :isPreview="isPreview"
                        v-if="currentQuestion.question_type == questionTypes.INTEGER"
                      />
                      <SubjectivePrivew
                        :showAnswerField="questionData.showAnswerField"
                        :currentQuestion="currentQuestion"
                        :isPreview="isPreview"
                        :openMandatoryQuePopup="openMandatoryQuePopup"
                        v-if="
                          currentQuestion.question_type == questionTypes.SUBJECTIVE ||
                          currentQuestion.question_type == questionTypes.SUBJECTIVEINTEGER
                        "
                      />
                      <MatrixMatchPrivew
                        :showAnswerField="questionData.showAnswerField"
                        :currentQuestion="currentQuestion"
                        :openMandatoryQuePopup="openMandatoryQuePopup"
                        v-if="currentQuestion.question_type == questionTypes.MATRIX_MATCH"
                      />

                      <MatrixMatchOptionPrivew
                        :showAnswerField="questionData.showAnswerField"
                        :currentQuestion="currentQuestion"
                        :openMandatoryQuePopup="openMandatoryQuePopup"
                        v-if="
                          currentQuestion.question_type ==
                          questionTypes.MATRIX_MATCH_OPTION
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </pinch-zoom>
            <!-- <div v-if="!isPreview" class="save-and-next-btn"> -->
            <!-- <v-btn
                v-if="
                  isPreview && !isUploadAndReplace &&
                    (!isTestCustom || currentQuestion.institute_id === null)
                "
                :disabled="isEditing || isAnswerBtnClicked"
                color="primary"
                @click="openReportErrorDialog()"
                class="cust-btn"
              >
                Report Error
              </v-btn>
              <v-btn
                v-if="
                  isPreview &&
                    isTestCustom &&
                    !isUploadAndReplace &&
                    !isSearchAnotherQ &&
                    currentQuestion.institute_id === null &&
                    currentQuestion.isQuestionEditable
                "
                color="primary"
				:disabled="isEditable"
                @click="uploadAndReplace()"
                class="cust-btn"
              >
                Upload & Replace
              </v-btn>
              <v-btn
                v-else-if="
                  isPreview &&
                    isTestCustom && (isSearchAnotherQ || isUploadAndReplace) &&
                    currentQuestion.isQuestionEditable
                "
                color="primary"
                @click="replaceToOriginal()"
                class="cust-btn"
              >
                Revert To Original
              </v-btn>
			                <v-btn
                color="primary"
                v-else-if="
                  isPreview &&
                    isTestCustom &&
                    currentQuestion.isQuestionEditable && currentQuestion.institute_id !==null
                "
                @click="editQuestion"
                class="cust-btn"
                >{{ isEditing ? "Done" : "Edit" }}</v-btn
              > -->
            <!-- <template>
                <v-btn
                  v-if="!isPreview"
                  :disabled="isEditing || isAnswerBtnClicked"
                  color="default"
                  @click="updateQuestionStatus(QUESTION_ACTIONS.REVIEW_LATER)"
                  class="cust-btn orange-btn mark-review-btn show-on-mobile"
                >
                  {{
                    isLastQuestion
                      ? "Mark for Review"
                      : "Mark for Review & Next"
                  }}
                </v-btn>
                <v-btn
                  v-if="!isPreview"
                  color="primary"
                  :disabled="isEditing || isAnswerBtnClicked"
                  @click="updateQuestionStatus(QUESTION_ACTIONS.SUBMIT)"
                  class="cust-btn show-on-mobile margin-right-5"
                >
                  {{ isLastQuestion ? "Save" : "Save & Next" }}
                </v-btn>
                <v-btn
                  color="default"
                  @click="clearReponse()"
                  :disabled="isAnswerBtnClicked"
                  v-if="!isPreview"
                  class="cust-btn clear-btn right-align show-on-mobile"
                >
                  Clear Response
                </v-btn>
              </template>
              <template>
                <v-btn
                  v-if="!isPreview"
                  :disabled="isEditing || isAnswerBtnClicked"
                  color="default"
                  @click="updateQuestionStatus(QUESTION_ACTIONS.REVIEW_LATER)"
                  class="cust-btn orange-btn mark-review-btn show-on-desktop"
                >
                  {{
                    isLastQuestion
                      ? "Mark for Review"
                      : "Mark for Review & Next"
                  }}
                </v-btn>
                <v-btn
                  color="default"
                  @click="clearReponse()"
                  :disabled="isAnswerBtnClicked"
                  v-if="!isPreview"
                  class="cust-btn clear-btn mx-2 show-on-desktop"
                >
                  Clear Response
                </v-btn>
                <v-btn
                  v-if="!isPreview"
                  color="primary"
                  :disabled="isEditing || isAnswerBtnClicked"
                  @click="updateQuestionStatus(QUESTION_ACTIONS.SUBMIT)"
                  class="cust-btn right-align show-on-desktop"
                >
                  {{ isLastQuestion ? "Save" : "Save & Next" }}
                </v-btn>
              </template> -->
            <!-- <v-btn
                color="primary"
                v-if="isTestCustom && isUploadAndReplace"
                @click="uploadAndReplace"
                class="cust-btn right-align"
              >
                Done</v-btn
              >
              <v-btn
                color="primary"
                v-if="isTestCustom && isSearchAnotherQ"
                @click="replaceSearchAnotherQuestion"
                class="cust-btn right-align"
              >
                Select Question</v-btn
              >
              <v-btn
                v-else-if="
                  isPreview && !isSearchAnotherQ && !isUploadAndReplace
                "
                color="primary"
                :disabled="isEditing"
                @click="updateQuestionStatus(QUESTION_ACTIONS.SUBMIT)"
                class="cust-btn right-align"
              >
                Next
              </v-btn> -->
            <!-- </div> -->
          </v-card>
        </div>
        <div class="test-counter-block show-desktop-panel">
          <div class="test-time-count">
            <div class="time-remaining-title">
              <v-btn
                v-if="isPreview && isTestCustom"
                @click="similarQuestionsPopup"
                class="question-bucket right-align"
                :class="{
                  active:
                    !isSearchAnotherQ &&
                    !isUploadAndReplace &&
                    currentQuestion.institute_id === null &&
                    !isEditable,
                }"
                ><div>
                  <div class="Bucket-que">Show All</div>
                  <div class="Bucket-select">Questions of Same Topic</div>
                </div></v-btn
              >
              <!-- <v-btn
                color="primary"
                v-else-if="
                  isPreview &&
                    isTestCustom &&
                    currentQuestion.isQuestionEditable && currentQuestion.institute_id !==null
                "
                @click="editQuestion"
                class="cust-btn right-align"
                >{{ isEditing ? "Done" : "Edit" }}</v-btn
              > -->
              <div v-else-if="!isPreview && showTimer">
                Time Remaining
                <h4 v-show="showTimer">
                  {{ this.timeRemainingString }}
                </h4>
              </div>
            </div>
            <div class="time-remaining-count">&nbsp;</div>
          </div>
          <div class="inner-block preview-test-cp3-public">
            <v-expansion-panels v-model="panel">
              <v-expansion-panel
                class="number-contet"
                :class="{ 'cp3-number-content-islive': !isPreview }"
                expand
                v-model="panel"
              >
                <v-expansion-panel-header>Question Palette</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="number-contet">
                    <LegendsPreview
                      v-if="questionData"
                      :questionStatus="questionStatus"
                      :questions="questionData.questions"
                      :isPreview="isPreview"
                      :isCustom="isTestCustom"
                    />
                    <div class="hr-div"></div>
                    <QuestionPallet
                      v-if="questionData"
                      @jumpToQuestion="jumpToQuestion"
                      :isEditing="isEditing"
                      :isPreview="isPreview"
                      :isPastTest="isPastTest"
                      :isCustom="isTestCustom"
                      :questionData="questionData"
                    />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div
              class="test-foter-blk"
              :class="{ 'cp3-footer-content-islive': !isPreview }"
            >
              <div
                class="test-btn-block-ans"
                :class="isPreview ? ' smallFont ' : 'cp3-makingt-text'"
              >
                <div class="marking marking-bold">
                  {{
                    questionData &&
                    questionData.mandatoryQuestions &&
                    (questionData.mandatoryQuestions.allow_all === 1 ||
                      questionData.mandatoryQuestions.allow_all === 0)
                      ? `Out of the ${questionData.questions.length} Questions ${questionData.mandatoryQuestions.mandatory_questions} are Mandatory`
                      : "All Questions in this section are Mandatory"
                  }}
                </div>
                <div class="marking">
                  {{
                    questionData && questionData.mandatoryQuestions
                      ? questionData.mandatoryQuestions.allow_all === 1
                        ? `You can answer all questions but the best  ${questionData.mandatoryQuestions.mandatory_questions} shall be evaluated`
                        : `You can only answer the mandatory number of questions`
                      : ""
                  }}
                </div>

                <div class="marking marking-bold">Marking Scheme for this section:</div>
                <div class="marking">
                  Correct Response:+
                  {{ currentQuestion.correct_marks }}
                </div>
                <div class="marking">
                  Incorrect Response:{{ currentQuestion.negative_marks }}
                </div>
                <div
                  class="marking"
                  v-if="isPreview && currentQuestion.partial_marking > 0"
                >
                  <v-icon small color="success">mdi-checkbox-marked</v-icon>
                  Partial Marking:{{ currentQuestion.partial_marking }}
                </div>
                <div
                  v-if="isPreview && currentQuestion.partial_marking == 0"
                  class="marking markingElse"
                >
                  <v-icon small color="success">mdi-checkbox-marked</v-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="test-bottom">
        <div class="bottom-logo">
          <!-- <img src="/img/logo-footer.c1b83f14.png" class="master-logo-btm" /> -->
        </div>
        <div class="test-btn-block-answering v-r-priview-test-view">
          <div class="save-and-next-btn save-finish-btn">
            <div class="mobile-upload-btn">
              <v-btn
                v-if="
                  isPreview &&
                  !isUploadAndReplace &&
                  (!isTestCustom || currentQuestion.institute_id === null )&&
                  !isAits
                "
                :disabled="isEditing || isAnswerBtnClicked"
                color="primary"
                @click="openReportErrorDialog()"
                class="cust-btn"
              >
                Report Error
              </v-btn>
              <v-btn
                v-if="
                  isPreview &&
                  isTestCustom &&
                  !isUploadAndReplace &&
                  !isSearchAnotherQ &&
                  currentQuestion.institute_id === null &&
                  currentQuestion.isQuestionEditable &&
                  !isAits
                "
                color="primary"
                :disabled="isEditable"
                @click="uploadAndReplace()"
                class="cust-btn pull-right"
              >
                Upload & Replace
              </v-btn>
              <v-btn
                v-else-if="
                  isPreview &&
                  isTestCustom &&
                  (isSearchAnotherQ || isUploadAndReplace) &&
                  currentQuestion.isQuestionEditable
                "
                color="primary"
                @click="replaceToOriginal()"
                class="cust-btn"
              >
                Revert To Original
              </v-btn>
              <v-btn
                color="primary"
                v-else-if="
                  isPreview &&
                  isTestCustom &&
                  currentQuestion.isQuestionEditable &&
                  currentQuestion.institute_id !== null
                "
                @click="editQuestion"
                class="cust-btn"
                >{{ isEditing ? "Done" : "Edit" }}</v-btn
              >
            </div>
            <div class="answering-btn">
              <v-btn
                v-if="!isPreview"
                :disabled="isEditing || isAnswerBtnClicked"
                color="default"
                @click="updateQuestionStatus(QUESTION_ACTIONS.REVIEW_LATER)"
                class="cust-btn orange-btn mark-review-btn left-align show-on-display"
              >
                {{ isLastQuestion ? "Mark for Review" : "Mark for Review & Next" }}
              </v-btn>
              <v-btn
                color="default"
                @click="clearReponse()"
                :disabled="isAnswerBtnClicked"
                v-if="!isPreview"
                class="cust-btn clear-btn clear-btn-mg left-align show-on-display"
              >
                Clear Response
              </v-btn>
              <v-btn
                v-if="!isPreview"
                color="primary"
                :disabled="isEditing || isAnswerBtnClicked"
                @click="updateQuestionStatus(QUESTION_ACTIONS.SUBMIT)"
                class="cust-btn margin-right-5 right-align show-on-display"
              >
                {{ isLastQuestion ? "Save" : currentQuestion.isAnswered? "Save & Next":"Next" }}
              </v-btn>
            </div>
            <!-- <template>
                <v-btn
                  v-if="!isPreview"
                  :disabled="isEditing || isAnswerBtnClicked"
                  color="default"
                  @click="updateQuestionStatus(QUESTION_ACTIONS.REVIEW_LATER)"
                  class="cust-btn orange-btn mark-review-btn show-on-mobile"
                >
                  {{
                    isLastQuestion
                      ? "Mark for Review"
                      : "Mark for Review & Next"
                  }}
                </v-btn>
                <v-btn
                  v-if="!isPreview"
                  color="primary"
                  :disabled="isEditing || isAnswerBtnClicked"
                  @click="updateQuestionStatus(QUESTION_ACTIONS.SUBMIT)"
                  class="cust-btn show-on-mobile margin-right-5"
                >
                  {{ isLastQuestion ? "Save" : "Save & Next" }}
                </v-btn>
                <v-btn
                  color="default"
                  @click="clearReponse()"
                  :disabled="isAnswerBtnClicked"
                  v-if="!isPreview"
                  class="cust-btn clear-btn right-align show-on-mobile"
                >
                  Clear Response
                </v-btn>
              </template>
              <template>
                <v-btn
                  v-if="!isPreview"
                  :disabled="isEditing || isAnswerBtnClicked"
                  color="default"
                  @click="updateQuestionStatus(QUESTION_ACTIONS.REVIEW_LATER)"
                  class="cust-btn orange-btn mark-review-btn show-on-desktop"
                >
                  {{
                    isLastQuestion
                      ? "Mark for Review"
                      : "Mark for Review & Next"
                  }}
                </v-btn>
                <v-btn
                  color="default"
                  @click="clearReponse()"
                  :disabled="isAnswerBtnClicked"
                  v-if="!isPreview"
                  class="cust-btn clear-btn mx-2 show-on-desktop"
                >
                  Clear Response
                </v-btn>
                <v-btn
                  v-if="!isPreview"
                  color="primary"
                  :disabled="isEditing || isAnswerBtnClicked"
                  @click="updateQuestionStatus(QUESTION_ACTIONS.SUBMIT)"
                  class="cust-btn right-align show-on-desktop"
                >
                  {{ isLastQuestion ? "Save" : "Save & Next" }}
                </v-btn>
              </template> -->
            <v-btn
              color="primary"
              v-if="isTestCustom && isUploadAndReplace"
              @click="uploadAndReplace"
              class="cust-btn right-align"
            >
              Done</v-btn
            >
            <v-btn
              color="primary"
              v-if="isTestCustom && isSearchAnotherQ"
              @click="replaceSearchAnotherQuestion"
              class="cust-btn right-align"
            >
              Select Question</v-btn
            >
            <v-btn
              v-else-if="isPreview && !isSearchAnotherQ && !isUploadAndReplace"
              color="primary"
              :disabled="isEditing"
              @click="updateQuestionStatus(QUESTION_ACTIONS.SUBMIT)"
              class="cust-btn right-align"
            >
              Next
            </v-btn>
          </div>
          <div class="finish-test-btn">
            <v-btn
              color="default"
              class="cust-btn finish-test"
              @click="closeFullScreen('manual')"
              :disabled="disableSecondaryAction || isSearchAnotherQ || isUploadAndReplace"
              >{{ isPreview ? "Close Preview" : "Finish Test" }}</v-btn
            >
          </div>
        </div>
      </div>
    </div>
    <div class="no-internet" v-else>
      <h4>
        Please check your internet connection. Reload the page or wait on this screen till
        internet is back.
      </h4>
    </div>
    <AlertBox
      :width="modalWidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import isMobile from "is-mobile";
import moment from "moment";
import momentDuration from "moment-duration-format";
momentDuration(moment);

import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

import QuestionPallet from "@/components/PreviewTest/QuestionPallet.vue";
import MiniQuestionPallet from "@/components/PreviewTest/MiniQuestionPallet.vue";
import LegendsPreview from "@/components/PreviewTest/LegendsPreview.vue";
import LegendsOnHover from "@/components/PreviewTest/LegendsOnHover.vue";
import Comprehension from "@/components/PreviewTest/Comprehension.vue";
import SingleAnsQuePrivew from "@/components/PreviewTest/SingleAnsQuePrivew.vue";
import MultipleCorrectPrivew from "@/components/PreviewTest/MultipleCorrectPrivew.vue";
import IntegerPrivew from "@/components/PreviewTest/IntegerPrivew.vue";
import SubjectivePrivew from "@/components/PreviewTest/SubjectivePrivew.vue";
import AssertionReasonPrivew from "@/components/PreviewTest/AssertionReasonPrivew.vue";
import MatrixMatchOptionPrivew from "@/components/PreviewTest/MatrixMatchOptionPrivew.vue";
import MatrixMatchPrivew from "@/components/PreviewTest/MatrixMatchPrivew.vue";

// importing components for edit mode
import SingleAnsQue from "@/components/QuestionType/SingleAnsQue.vue";
import MultipleCorrect from "@/components/QuestionType/MultipleCorrect.vue";
import Subjective from "@/components/QuestionType/Subjective.vue";
import Integer from "@/components/QuestionType/Integer.vue";
import MatrixMatchOption from "@/components/QuestionType/MatrixMatchOption.vue";
import MatrixMatch from "@/components/QuestionType/MatrixMatch.vue";
import Comprehensions from "@/components/QuestionType/Comprehensions.vue";
import TC from "@/components/QuestionType/TC.vue";

// importing axios to cancel heartbeat request if it is pending state till the next heartbeat is called
import axios from "axios";
import NoSleep from "nosleep.js";
import constants from "@/utils/constants.js";
let noSleep = new NoSleep();
let sendRelicInterval;
export default {
  name: "PreviewTest",
  components: {
    QuestionPallet,
    MiniQuestionPallet,
    LegendsPreview,
    LegendsOnHover,
    Comprehension,
    SingleAnsQuePrivew,
    MultipleCorrectPrivew,
    IntegerPrivew,
    SubjectivePrivew,
    AssertionReasonPrivew,
    MatrixMatchOptionPrivew,
    MatrixMatchPrivew,
    SingleAnsQue,
    MultipleCorrect,
    Subjective,
    Integer,
    MatrixMatchOption,
    MatrixMatch,
    Comprehensions,
    TC,
    Carousel,
    Slide,
  },
  async mounted() {
    this.maxHeight = window.innerHeight;
    document.addEventListener("visibilitychange", () => {
      console.log(document.visibilityState);
      // Modify behavior…
    });
    window.addEventListener("online", this.updateStatus);
    window.addEventListener("offline", this.updateStatus);

    // sessionStorage.removeItem('limitCrossed')
    localStorage.removeItem("searchedQuestion");
    localStorage.removeItem("currentQuestion");
    let testValue = JSON.parse(localStorage.getItem("myInstitute"));
    this.currentInstituteId = testValue.id
    this.dummyOptions = [
      {
        index: this.OPTIONS_ABC[0],
        option_text: "",
        correct_answer: false,
      },
      {
        index: this.OPTIONS_ABC[1],
        option_text: "",
        correct_answer: false,
      },
      {
        index: this.OPTIONS_ABC[2],
        option_text: "",
        correct_answer: false,
      },
      {
        index: this.OPTIONS_ABC[3],
        option_text: "",
        correct_answer: false,
      },
    ];
    this.dummyOptionsABC = [
      {
        index: this.OPTIONS_ABC[0],
        option_text: "",
        column: 1,
        correct_answer: "",
      },
      {
        index: this.OPTIONS_ABC[1],
        option_text: "",
        column: 1,
        correct_answer: "",
      },
    ];
    this.dummyOptionsPQR = [
      {
        index: this.OPTIONS_PQR[0],
        option_text: "",
        column: 2,
        correct_answer: "",
      },
      {
        index: this.OPTIONS_PQR[1],
        option_text: "",
        column: 2,
        correct_answer: "",
      },
    ];
    this.questionTypes = this.QUE_TYPES;
    this.questionStatus = this.QUESTION_STATUS;
    this.questionStatusColor = this.QUESTION_STATUS_COLOR;
    this.setIsPastTest(false);
    if (this.user.role_id === this.roleIds.TR) {
      this.getTeacherSubjectTree();
      this.getAssignTestStatus();
    }

    await this.setCustomData();
    this.reverseQuestionsType();
    this.requestGetTestDetails();
    window.addEventListener("beforeunload", event => {
      if (this.testDetails && !this.isPreview) {
        this.heartBeat("refresh");
      }
    });

    this.renderMath();
    if (this.isPreview) {
      this.getSkillSets();
    }
    this.setDisableSecondaryAction(false);
  },
  data() {
    return {
      isPastTest: false,
      is_preview: true,
      modalWidth: "1000px",
      instructionsTooltip: null,
      cComponent: "components/coordinator/Questionadd",
      alertBoxData: {},
      persistent: false,
      status: false,
      testDetails: null,
      questionTypes: this.QUE_TYPES,
      questionStatus: this.QUESTION_STATUS,
      questionStatusColor: this.QUESTION_STATUS_COLOR,
      questionTypesReversed: {},
      questionsList: {},
      questionData: {},
      panel: 0,
      questions: [],
      currentQuestion: {},
      legendsData: {
        answered: 0,
        reviewLater: 0,
        answeredReviewLater: 0,
        notVisited: 0,
        notAnswered: 0,
        easy: 0,
        moderate: 0,
        tough: 0,
      },
      instructions: "",
      isEditing: false,
      currentQuestionToBeEdited: {},
      showNextButton: false,
      isTestCustom: true,
      isPreview: false,
      scrollPerPage: false,
      direction: "",
      endAction: "",
      duration: null,
      timeRemainingString: "",
      timeRemainingInterval: null,
      heartBeatInterval: null,
      isOnline: true,
      timeObj: null,
      chapters: [],
      perPageCustom: [
        [1900, 6],
        [1650, 5],
        [1550, 4],
        [1400, 3],
        [1300, 3],
        [1280, 3],
        [1024, 2],
        [768, 2],
        [480, 1],
        [340, 1],
      ],
      pageStatus: [],
      pageInactive: false,
      inactiveStartTime: null,
      nextQuestionIndex: 0,
      showNextQuestion: true,
      isSQTChanged: false,
      isAnswerBtnClicked: false,
      scrollQtypeValue: null,
      isBlurred: false,
      hideTimer: false,
      finishTestError: null,
      responseTimeOut: null,
      cancelBeatSource: null,
      showTimer: false,
      expansionPanelStatus: [],
      remainingTimeInterval: null,
      testAutoFinished: false,
      topics: [],
      concepts: [],
      skillset: [],
      selectedTopic: {},
      difficulty: constants.DIFFICULTY_LEVELS,
      studentResponse: constants.ROLES.ST_ROLE_CODE,
      selectedDifficultyLevel: {},
      selectedSubTopic: {},
      selectedConcept: {},
      searchAnotherQuestions: {},
      isSearchAnotherQ: false,
      isUploadAndReplace: false,
      isEditable: false,
      teacherSubjectId: [],
      dummyOptionsPQR: [],
      dummyOptions: [],
      dummyOptionsABC: [],
      AssignedTeacher: [],
      questionAnsweredCount: 0,
      isCallBucketApi: false,
      isDBTest: false,
      isOnlineTest: true,
      noOfTimesTabChanged: 0,
      autoSubmitEndAction: "",
      autoSubmitError: "",
      navigateTo: 0,
      isApiCall: true,
      pageBlurredTrigger: null,
      windowSize: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
      browserPrefixes: ["moz", "ms", "o", "webkit"],
      isVisible: true, // internal flag, defaults to true
      browserPrefix: null,
      hiddenPropertyName: null,
      visibilityEventName: null,
      maxHeight: 0,
      paperCoverage: {},
      showTags: false,
      isAits:false,
      currentInstituteId:''
    };
  },
  destroyed() {
    console.log("In destroyed");
    this.clearAllIntervals();
    noSleep.disable();
    document.removeEventListener("visibilitychange", this.checkVisiblity, false);
    window.removeEventListener("online", this.updateStatus);
    window.removeEventListener("offline", this.updateStatus);
    document.removeEventListener("contextmenu", null, false);
    window.removeEventListener("popstate", null);
    clearInterval(sendRelicInterval);
    window.onpopstate = null;
    window.onblur = null;
    window.onfocus = null;
    this.scrollToTop();
  },
  computed: {
    ...mapState("userStore", ["user", "pendingTestList"]),

    ...mapGetters("testStore", {
      questionsListStore: "questionsList",
      filteredQuestionsList: "filteredQuestionsList",
      testData: "testData",
      subjectQuestionTypeList: "subjectQuestionTypeList",
      selectedSQTIndex: "selectedSQTIndex",
      disableSecondaryAction: "disableSecondaryAction",
    }),
    isLastQuestion() {
      if (
        this.subjectQuestionTypeList &&
        this.selectedSQTIndex == this.subjectQuestionTypeList.length - 1 &&
        this.questionData.currentQuestionIndex == this.questions.length - 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    isStudent() {
      return this.user.role_id === this.roleIds.ST;
    },
    hasInstructions() {
      return this.testDetails && this.testDetails.instructions;
    },
    shouldShowVerticalLine() {
      return !this.isStudent || (this.isStudent && this.hasInstructions);
    },
    instructionsText() {
      return this.hasInstructions ? 'Instructions' : 'Add Instructions';
    },
    iconType() {
      return this.hasInstructions ? 'mdi-alert-circle' : 'mdi-plus-circle';
    },
  },
  watch: {
    instructionsTooltip(val) {
      this.renderMath();
    },
    // status(val){
    // 	if(!val){
    // 		this.requestGetTestDetails();
    // 	}
    // },
    // selectedSQTIndex(newVal) {
    // this.getQuestionData();
    // this.renderMath();
    // },
    subjectQuestionTypeList(newVal) {
      this.endAction = this.QUESTION_ACTIONS.TEST_STARTED;
      this.showNextQuestion = true;
      this.getQuestionData();
      this.renderMath();
    },
  },
  methods: {
    ...mapActions({
      setTestData: "testStore/setTestData",
      remainingTime: "testStore/remainingTime",
      setSubjectQuestionTypeList: "testStore/setSubjectQuestionTypeList",
      setFilteredQuestionsList: "testStore/setFilteredQuestionsList",
      setSelectedSQTIndex: "testStore/setSelectedSQTIndex",
      setSelectedQuestionIndex: "testStore/setSelectedQuestionIndex",
      getTestPreviewDetails: "testStore/getTestPreviewDetails",
      getLiveTestDetails: "testStore/getLiveTestDetails",
      setQuestions: "questionStore/setQuestions",
      getTabChangeCount: "testStore/getTabChangeCount",
      createTest: "testStore/createTest",
      uploadAndReplaceQuestion: "testStore/uploadAndReplaceQuestion",
      updateProgressInDB: "testStore/updateProgressInDB",
      updateHeartBeat: "testStore/updateHeartBeat",
      setIsTestStarted: "testStore/setIsTestStarted",
      setPendingTestList: "userStore/setPendingTestList",
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
      setDisableSecondaryAction: "testStore/setDisableSecondaryAction",
      logOut: "userStore/logOut",
      searchAnotherQuestion: "testStore/searchAnotherQuestion",
      setPendingTestList: "userStore/setPendingTestList",
      getTeacherSubject: "userStore/getTeacherSubject",
      replaceTestQuestion: "testStore/replaceTestQuestion",
      assignTestStatus: "testStore/assignTestStatus",
      setAnswerCount: "testStore/setAnswerCount",
      getRefData: "utilStore/getRefData",
      getQuesDateAndViewCountOfLastCreQues:
        "testStore/getQuesDateAndViewCountOfLastCreQues",
      autoSubmit: "testStore/autoSubmit",
      logData: "testStore/logData",
      updateTestInstructions: "testStore/updateTestInstructions",
    }),
    ...mapMutations("testStore", ["setIsPastTest"]),
    // onClose(data) {
    //   this.status = data.status;
    //    if(data.reload){
    // 	  this.requestGetTestDetails();
    //   }
    // },
    openReportErrorDialog() {
      
      this.alertBoxData = {
        test_id: this.testDetails ? this.testDetails.id : this.$route.params.test_id,
        question: this.currentQuestion,
        errorDescription: "",
      };
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent = "components/student/Tests/PastTests/ReportError";
      this.$forceUpdate();
    },
    getChapters(subjectId, subSubject) {
      if (subjectId && this.isPreview) {
        this.chapters = [];
        let reqData = {
          level: 3,
          parent: subjectId,
          sub_subject: subSubject,
          target_exam: this.testDetails.target,
        };
        // this.$root.showLoader = true;
        this.getDataTreeWithLevel(reqData)
          .then(response => {
            // this.$root.showLoader = false;
            this.chapters = response.map(x => {
              let c = {};
              c.text = x.title;
              c.value = { chapter_id: x.id, title: x.title };
              return c;
            });
          })
          .catch(err => {
            // this.$root.showLoader = false;
          });
      }
    },
    similarQuestionsPopup() {
      this.alertBoxData = {
        question: {
          ...this.currentQuestion,
          target_exam: this.testDetails.target,
          test_id: this.testDetails.id,
        },
        errorDescription: "",
        isPreview: this.isPreview,
        isEditable: this.isEditable,
        isCallBucketApi: this.isCallBucketApi,
      };
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent = "components/coordinator/Tests/CustomizedTests/SimilarQuestions";
      this.$forceUpdate();
    },
    getTopics(chapterId) {
      if ((chapterId || this.slectedChapter.chapter_id) && this.isPreview) {
        let reqData = {
          level: 4,
          parent: chapterId || this.slectedChapter.chapter_id,
          target_exam: this.testDetails.target,
        };
        // this.selectedSubTopic = {};
        this.subTopics = [];
        //this.selectedConcept = {};
        this.concepts = [];
        // this.$root.showLoader = true;
        if (this.isSearchAnotherQ) {
          this.selectedTopic.topic_id = null;
          this.selectedTopic.title = null;
        }

        this.getDataTreeWithLevel(reqData)
          .then(response => {
            // this.$root.showLoader = false;
            this.topics = response.map(x => {
              let c = {};
              c.text = x.title;
              c.value = { topic_id: x.id, title: x.title };
              return c;
            });
          })
          .catch(err => {
            // this.$root.showLoader = false;
          });
      }
    },

    onSelectChapter(e) {
      sessionStorage.removeItem("selectedQuestionIds");

      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.chapterId = e.chapter_id;
        this.currentQuestionToBeEdited.chapterName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.chapterId = e.chapter_id;
        this.currentQuestion.chapterName = e.title;
      }
      this.selectedSubTopic.subtopic_id = null;
      this.selectedTopic.topic_id = null;
      this.selectedTopic.title = null;
      this.getTopics(e.chapter_id);
    },
    onSelectedTopic(e) {
      sessionStorage.removeItem("selectedQuestionIds");

      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.topic_id = e.topic_id;
        this.currentQuestionToBeEdited.topicName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.topic_id = e.topic_id;
        this.currentQuestion.topicName = e.title;
      }
      this.getSubTopics(e.topic_id);
      //this.getConcepts(e.topic_id);
    },
    onselectedDifficulty(e) {
      sessionStorage.removeItem("selectedQuestionIds");

      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.difficultyId = e.id;
        this.currentQuestionToBeEdited.difficultyName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.difficultyId = e.id;
        this.currentQuestion.difficultyName = e.title;
      }
    },

    getRemainingTimeInterval() {
      this.remainingTimeInterval = setInterval(() => {
        if (!document.hidden && document.hasFocus()) {
          this.getRemainingTime(true);
        }
      }, 120 * 1000);
    },
    startTimer(timeRemaining) {
      let timeFromBackend = moment.duration(timeRemaining, "minutes");
      let updateTimeRemaining = true;
      if (this.timeObj) {
        try {
          let diffInSeconds = Math.abs(
            this.timeObj.asSeconds() - timeFromBackend.asSeconds()
          );
          if (diffInSeconds > 15) {
            updateTimeRemaining = true;
          } else {
            updateTimeRemaining = false;
          }
        } catch (error) {
          updateTimeRemaining = false;
          this.$toasted.error("Error setting timer. Please reload page.");
          location.reload();
        }
      }
      // if(!updateTimeRemaining) return;
      if (timeRemaining > 0) {
        let timeObj = null;
        if (updateTimeRemaining) {
          timeObj = moment.duration(timeRemaining, "minutes");
        } else if (!updateTimeRemaining && this.timeRemainingInterval) {
          return; // return if timer is not stopped due to pagevisibility
        } else {
          timeObj = this.timeObj;
        }
        if (this.timeRemainingInterval) {
          clearInterval(this.timeRemainingInterval);
        }
        this.timeRemainingInterval = setInterval(() => {
          if (this.isOnline) {
            timeObj.subtract(1, "seconds");
            this.timeObj = timeObj;
            let timeRemainingString = timeObj.format("hh:mm:ss");
            if (
              timeRemainingString == "00" ||
              (timeObj.hours() <= 0 && timeObj.minutes() <= 0 && timeObj.seconds() <= 0)
            ) {
              this.timeRemainingString = "0";
              this.finishTest("timeUp");
            } else {
              this.timeRemainingString = timeObj.format("hh:mm:ss");
            }
            this.hideTimer = false;
          }
        }, 1000);
      } else {
        this.$toasted.error("The amount of time given for this test is over.");
        this.setIsTestStarted(false);
        this.$router.push({ name: this.user.role_id === this.roleIds.ST?"live-test":"schedule-tests"});
      }
    },
    startHeartBeatTimer() {
      if (this.heartBeatInterval) {
        clearInterval(this.heartBeatInterval);
      }
      this.heartBeatInterval = setInterval(() => {
        this.heartBeat();
      }, this.HEART_BEAT_TIME);
    },
    cancelPendingBeats() {
      if (this.cancelBeatSource) {
        this.cancelBeatSource.cancel();
      }
    },
    heartBeat() {
      // if (this.pageInactive) {
      //     let currentTime = moment();
      //     let duration = moment.duration(
      //         currentTime.diff(this.inactiveStartTime)
      //     );
      //     let minutes = duration.asMinutes();
      //     if (!document.hidden && minutes > 3.0) {
      //         this.getRemainingTime();
      //     }
      // }
      if (!document.hidden && this.isBlurred && document.hasFocus()) {
        this.getRemainingTime(false);
      }

      this.cancelPendingBeats();
      this.cancelBeatSource = axios.CancelToken.source();

      let postData = {
        test_institute_id:
          this.testDetails && this.testDetails.test_institute_id
            ? this.testDetails.test_institute_id
            : this.$route.params && this.$route.params.test_institute_id
            ? this.$route.params.test_institute_id
            : 0,
        question_id: this.currentQuestion.id,
        test_detail_id: this.currentQuestion.test_detail_id,
        test_schedule_id: this.testDetails ? this.testDetails.test_schedule_id : -1,
        beat: this.cancelBeatSource,
      };
      if (parseInt(postData.test_institute_id) == 0) {
        let errObj = {
          errMsg: "test_institue_id not found",
        };
        this.sendLogData(errObj, "heart-beat", "live-test-api", postData);
      }
      this.updateHeartBeat(postData)
        .then(res => {
          this.cancelBeatSource = null;
          this.isOnline = true;
        })
        .catch(err => {
          let errObj = "";
          if (err && err.data && err.data.errors) {
            errObj = err.data.errors;
          } else if (err && err.data) {
            errObj = err.data;
          } else {
            errObj = err;
          }
          let error_log = new Error(`
          **HEART-BEAT **LIVE ST::${this.user.id + ""}:${
            this.testDetails.test_schedule_id
          },
          api:'heart-beat',
          payload:${JSON.stringify(postData)},
          error:${JSON.stringify(errObj)},
          networkStatus: ${navigator.onLine},
          user_id: ${this.user.id}`);
          localStorage.setItem("error_live_test", error_log);
          this.sendLogData(errObj, "heart-beat", "live-test-api", postData);
          console.log("in heart error", error_log);
          if (
            !err.data ||
            !(err.data.errors[0].code == "ERR419" || err.data.errors[0].code == "ERR401")
          ) {
            this.isOnline = false;
          }
        });
    },
    clearAllIntervals() {
      if (this.timeRemainingInterval) {
        clearInterval(this.timeRemainingInterval);
      }
      // this is to close the interval which get remaining time every 2 minutes
      if (this.remainingTimeInterval) {
        clearInterval(this.remainingTimeInterval);
      }
      if (this.heartBeatInterval) {
        clearInterval(this.heartBeatInterval);
      }
      if (this.responseTimeOut) {
        clearInterval(this.responseTimeOut);
      }
    },
    scrollToTop() {
      let content = this.$refs.questionBox;
      if (content) content.scrollTop = 0;
      let scrollElem = document.getElementsByClassName("v-application--wrap");
      scrollElem[0].scrollIntoView();
    },
    gotoDirection(scrollPerPage, direction) {
      this.direction = direction;
      // this.scrollPerPage = scrollPerPage;
      this.$refs.carousel.currentPage = Math.round(
        this.$refs.carousel.offset / this.$refs.carousel.slideWidth
      );
      if (this.direction == "backward" && this.$refs.carousel.currentPage == 1) {
        this.$refs.carousel.handleNavigation(this.direction);
        return;
      }
      this.scrollPerPage = scrollPerPage;
      this.$refs.carousel.currentPage = this.scrollPerPage
        ? Math.round(
            this.$refs.carousel.offset /
              this.$refs.carousel.slideWidth /
              this.$refs.carousel.currentPerPage
          )
        : Math.round(this.$refs.carousel.offset / this.$refs.carousel.slideWidth);
      this.$refs.carousel.handleNavigation(this.direction);
    },
    legendsForWholeTest() {
      let legends = [];

      this.subjectQuestionTypeList.forEach(sqtl => {
        var questions = [];
        questions = sqtl.questions;
        let legendsData = {
          answered: 0,
          reviewLater: 0,
          answeredReviewLater: 0,
          notVisited: 0,
          notAnswered: 0,
          questions: questions.length,
          name: sqtl.name,
        };
        questions.forEach(val => {
          if (val.status == this.QUESTION_STATUS.ANSWER_SELECTED_SAVED) {
            legendsData.answered++;
          }
          if (val.status == this.QUESTION_STATUS.ANSWER_NOT_SELECTED_REVIEW) {
            legendsData.reviewLater++;
          }
          if (val.status == this.QUESTION_STATUS.ANSWER_SELECTED_REVIEW) {
            legendsData.answeredReviewLater++;
          }
          if (val.status < this.QUESTION_STATUS.VISITED) {
            legendsData.notVisited++;
          }
          if (
            (val.status == this.QUESTION_STATUS.VISITED && !val.isAnswered) ||
            val.status == this.QUESTION_STATUS.ANSWER_NOT_SELECTED_SAVED
          ) {
            legendsData.notAnswered++;
          }
        });
        legends.push(legendsData);
      });
      return legends;
    },
    gotoSummary() {
      try {
        if (!this.isPreview) {
          let testData = {
            timeRemaining: this.timeRemainingString,
            isTimeUp: this.timeRemainingString == "0" ? true : false,
            // subjectQuestionTypeList: this.subjectQuestionTypeList,
            legends: this.legendsForWholeTest(),
            testId: this.testDetails.id,
            instituteId: this.testDetails.test_institute_id,
            testScheduleId: this.testDetails.test_schedule_id,
            questionId: this.currentQuestion.id,
            testDetailId: this.currentQuestion.test_detail_id,
            timeObj: this.timeObj,
            testType: this.testDetails.test_type,
            isAutoFinished: this.testAutoFinished,
          };
          let routeInfo = {
            path: this.$route.path,
            testFinished: false,
          };
          sessionStorage.setItem("routeInfo", JSON.stringify(routeInfo));
          sessionStorage.setItem("testData", JSON.stringify(testData));
          sessionStorage.setItem("timeObj", JSON.stringify(this.timeObj));
          localStorage.setItem("previousPath", this.$route.path);
        }
        this.$root.showLoader = false;
        console.log("Redirecting To exam-summary");
        this.$router.push({ name: "exam-summary" }).catch(err => console.error(err));
      } catch (e) {
        this.finishTestError = e;
        this.endAction = this.QUESTION_ACTIONS.FINISH_TEST_ERROR;
        this.saveCurrentAction("currentQuestion");
      }

      // if (this.isPreview) this.$router.back();
    },
    closeFullScreen(status) {
      if (document.fullscreenElement) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }

      this.finishTest(status);
    },
    finishTest(status) {
      if (!this.isPreview) {
        this.clearAllIntervals();
        this.endAction = this.QUESTION_ACTIONS.FINISH_TEST;
        this.showNextQuestion = false;
        this.testAutoFinished = false;
        if (status == "timeUp") {
          this.testAutoFinished = true;
        }
        this.saveCurrentAction("currentQuestion");
      } else {
        if (this.isEditing) {
          this.$toasted.error(
            "The changes you have made to this question have not been saved. Please click on Done to save the changes."
          );
        } else {
          this.removeCookie();
          this.redirectAsTypePreview();
        }
      }
    },
    removeCookie() {
      let currentTestCookieExists = this.$cookies.isKey("CATAPULT_TEST");
      if (currentTestCookieExists) {
        this.$cookies.remove("CATAPULT_TEST");
      }
    },
    redirectAsTypePreview() {
      let route = "customized-tests";
      let routeName = localStorage.getItem("routeName");
      let previousRoute = localStorage.getItem("previousRoute");
      noSleep.disable();
      if (routeName != "preview-test") {
        routeName = this.$route.name;
      }
      if (routeName == "result-anaylysis-preview-test") {
        route = "test-results";
      } else if (previousRoute === "assign-tests") {
        route = previousRoute;
      } else if (previousRoute === "past-test-institute") {
        route = "past-test-institute";
      } else {
        switch (this.testDetails.test_type) {
          case this.TEST_TYPE.COMPLIMENTARY:
            route = "complimentary-test";
            break;
          case this.TEST_TYPE.ALL_INDIA_TEST:
            route = "all-india-test-series";
            break;
          case this.TEST_TYPE.CUSTOM:
            route = "customized-tests";
            break;
        }
      }
      localStorage.removeItem("routeName");
      localStorage.removeItem("previousRoute");
      localStorage.removeItem("previousPath");
      this.$router.push({ name: route });
    },
    showInstructions() {
      this.alertBoxData = {};
      this.alertBoxData.selectedTest = {
        instructions: this.instructions,
      };
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent = "components/coordinator/Tests/InstructionsPopup";
      this.$forceUpdate();
    },
    setCustomData() {
      let routeName = this.$route.name;
      if (routeName == "preview-test" || routeName == "result-anaylysis-preview-test") {
        this.hideTimer = true;
        this.showTimer = false;
        this.isPreview = true;
      } else {
        this.setIsTestStarted(true);
        this.disableNavigation(); // user cannot go back
        this.handleKeyboardEvents();

        // give user the ability to stop reload
        // let that = this;
        // window.onbeforeunload = function(event) {
        //     that.heartBeat();
        //     event.preventDefault();
        //     return false;
        // };
      }
      if (this.isPreview && routeName == "preview-test") {
        localStorage.setItem("routeName", routeName);
      }
    },
    uploadAndReplace() {
      if (this.isUploadAndReplace) {
        // saving the edited data
        if (this.validation(this.currentQuestionToBeEdited)) {
          this.updateUploadAndReplace();
        }
      } else {
        // edit current question
        localStorage.setItem("currentQuestion", JSON.stringify(this.currentQuestion));
        this.currentQuestionToBeEdited = {};
        this.currentQuestionToBeEdited = _.cloneDeep(this.currentQuestion);
        this.currentQuestionToBeEdited = this.setDummyAnswerAsPerType(
          this.currentQuestion
        );
        if (
          this.currentQuestion.question_type == this.questionTypes.COMPREHENSION ||
          this.currentQuestion.question_type == this.questionTypes.TC
        ) {
          this.currentQuestionToBeEdited.question_text = this.currentQuestion.passage;
          this.currentQuestionToBeEdited.id = this.currentQuestion.parent_id;
          let question = this.subjectQuestionTypeList[
            this.selectedSQTIndex
          ].questions.filter(
            q => q.parent_id && q.parent_id === this.currentQuestion.parent_id
          );
          this.currentQuestionToBeEdited.questions.forEach(ques => {
            ques.passage = "";
            ques.question_text = "";
            ques.questionNo = "";
          });
          for (let i = 0; i < question.length; i++) {
            this.currentQuestionToBeEdited.questions[i].questionNo =
              question[i].questionNo;
          }
        }
        this.currentQuestionToBeEdited.question_text = "";
        (this.currentQuestionToBeEdited.solution = []), (this.selectedTopic = {});
        this.selectedDifficultyLevel = {};
        (this.selectedSkillSet = {}), (this.slectedChapter = {});
        this.selectedSubTopic = {};
        this.selectedConcept = {};

        this.isUploadAndReplace = true;
        this.$forceUpdate();
        this.$nextTick(() => {
          this.$refs.chapterName.focus();
        });
      }
    },

    editQuestion() {
      if (this.isEditing) {
        // saving the edited data
        if (this.validation(this.currentQuestionToBeEdited)) {
          this.updateEditedQuestion();
        }
      } else {
        // edit current question
        this.currentQuestionToBeEdited = {};
        this.currentQuestionToBeEdited = _.cloneDeep(this.currentQuestion);
        if (
          this.currentQuestion.question_type == this.questionTypes.COMPREHENSION ||
          this.currentQuestion.question_type == this.questionTypes.TC
        ) {
          this.currentQuestionToBeEdited.question_text = this.currentQuestion.passage;
          this.currentQuestionToBeEdited.id = this.currentQuestion.parent_id;
          let question = this.subjectQuestionTypeList[
            this.selectedSQTIndex
          ].questions.filter(
            q => q.parent_id && q.parent_id === this.currentQuestion.parent_id
          );
          this.currentQuestionToBeEdited.questions = [];
          question.map(q => {
            this.currentQuestionToBeEdited.questions.push(_.cloneDeep(q));
          });
        }

        this.getTopics(this.currentQuestion.chapterId);
        this.isEditing = true;
        this.getSubTopics(this.currentQuestion.topic_id);
        this.getConcepts(this.currentQuestion.subtopic_id);

        this.$forceUpdate();
        this.$nextTick(() => {
          this.$refs.chapterName.focus();
        });
      }
    },
    updateUploadAndReplace() {
      let stepOneData = {};
      let list = [];
      let forUpdate = true;
      let q = _.cloneDeep(this.currentQuestionToBeEdited);
      if (this.validate()) {
        this.$root.showLoader = true;

        let obj = {
          // id: q.id,
          question_text: q.question_text,
          question_type: q.questionType.id,
          subtype: q.subtype ? q.subtype : null,
          data_type_id: q.chapterId,
          topic_id: q.topic_id,
          subtopic_id: q.subtopic_id,
          concept_id: q.concept_id,
          answer_type: q.answer_type,
          time: q.time,
          difficulty: q.difficultyId,
          correct_marks: q.correct_marks.toString(),
          negative_marks: q.negative_marks.toString(),
          partial_marking: q.partial_marking.toString(),
          questions: q.questions
            ? q.questions.map(x => {
                x.id = undefined;
                if (x.options) {
                  x.options.map(y => {
                    y.id = undefined;
                    return y;
                  });
                }
                return x;
              })
            : null,
          solution: q.solution,
          hints: this.getHintsForRequest(q.hints),
          test_detail_id: q.test_detail_id,
        };

        if (
          q.questionType.id === this.questionTypes.INTEGER ||
          q.questionType.id === this.questionTypes.SUBJECTIVE ||
          q.questionType.id === this.questionTypes.SUBJECTIVEINTEGER
        ) {
          obj.correct_answer = q.correct_answer;
        } else {
          obj.correct_answer = "-";
        }
        if (
          q.questionType.id === this.questionTypes.ASSERTION_REASON ||
          q.questionType.id === this.questionTypes.MULTIPLE_CORRECT ||
          q.questionType.id === this.questionTypes.SINGLE_CORRECT ||
          q.questionType.id === this.questionTypes.SINGLE_CORRECT_SEC2
        ) {
          obj.options = q.options.map(x => {
            x.id = undefined;
            return x;
          });
        } else if (q.questionType.id === this.questionTypes.MATRIX_MATCH) {
          obj.options = q.options_abc
            .map(x => {
              x.id = undefined;
              return x;
            })
            .concat(
              q.options_pqr.map(x => {
                x.id = undefined;
                return x;
              })
            );
        } else if (q.questionType.id === this.questionTypes.MATRIX_MATCH_OPTION) {
          obj.options = q.options
            .map(x => {
              x.id = undefined;
              return x;
            })
            .concat(
              q.options_abc.map(x => {
                x.id = undefined;
                return x;
              })
            )
            .concat(
              q.options_pqr.map(x => {
                x.id = undefined;
                return x;
              })
            );
        }
        list.push(obj);

        stepOneData.testName = this.testDetails.test_name;
        stepOneData.duration = this.testDetails.duration;
        stepOneData.selectedTarget = this.testDetails.target;
        stepOneData.testId = this.testDetails.id;
        stepOneData.testType = this.testDetails.test_type;

        let reqData = {
          list: list,
          target: stepOneData.selectedTarget,
          test_type: stepOneData.testType ? stepOneData.testType : this.TEST_TYPE.CUSTOM,
          duration: stepOneData.duration,
          test_name: stepOneData.testName,
          instructions: this.instructions,
          only_question: true,
        };

        if (stepOneData.testId) {
          reqData.id = stepOneData.testId;
          reqData.test_id = stepOneData.testId;
        }
        obj.target_exam = stepOneData.selectedTarget;
        this.uploadAndReplaceQuestion(obj)
          .then(response => {
            this.$root.showLoader = false;
            this.$toasted.success(`${response.message}`, {
              icon: "check_circle",
            });
            this.isUploadAndReplace = false;
            
            this.updateSearchAnotherQuestion(
              response.questionData,
              this.currentQuestionToBeEdited
            );
            this.currentQuestion.id = response.questionData.id;
            // this.currentQuestion.show_extra_details = false;
              this.currentQuestion.question_view_count= 0;
              this.currentQuestion.last_created_at = null;
              this.currentQuestion.historyDetails = [];
                  this.currentQuestion.institute_id = this.user.institute;
            localStorage.removeItem("currentQuestion");
            if (
              q.questionType.id === this.questionTypes.COMPREHENSION ||
              q.questionType.id === this.questionTypes.TC
            ) {
              this.requestGetTestDetails();
            }
          })
          .catch(err => {
            this.$root.showLoader = false;
          });
      }
    },
    updateEditedQuestion() {
      let stepOneData = {};
      let list = [];
      let forUpdate = true;
      let q = _.cloneDeep(this.currentQuestionToBeEdited);
      if (this.validate()) {
        this.$root.showLoader = true;
        let obj = {
          id: q.id,
          question_text: q.question_text,
          question_type: q.questionType.id,
          subtype: q.subtype ? q.subtype : null,
          data_type_id: q.chapterId,
          topic_id: q.topic_id,
          subtopic_id: q.subtopic_id,
          concept_id: q.concept_id,
          answer_type: q.answer_type,
          difficulty: q.difficultyId,
          correct_marks: q.correct_marks.toString(),
          negative_marks: q.negative_marks.toString(),
          partial_marking: q.partial_marking.toString(),
          questions: q.questions ? q.questions : null,
          solution: q.solution,
          hints: this.getHintsForRequest(q.hints),
        };

        if (
          q.questionType.id === this.questionTypes.INTEGER ||
          q.questionType.id === this.questionTypes.SUBJECTIVE ||
          q.questionType.id === this.questionTypes.SUBJECTIVEINTEGER
        ) {
          obj.correct_answer = q.correct_answer;
        } else {
          obj.correct_answer = "-";
        }
        if (
          q.questionType.id === this.questionTypes.ASSERTION_REASON ||
          q.questionType.id === this.questionTypes.MULTIPLE_CORRECT ||
          q.questionType.id === this.questionTypes.SINGLE_CORRECT_SEC2 ||
          q.questionType.id === this.questionTypes.SINGLE_CORRECT
        ) {
          obj.options = q.options;
          obj.options.map(o => {
            delete o["id"];
            delete o["question_id"];
          });
        } else if (q.questionType.id === this.questionTypes.MATRIX_MATCH) {
          obj.options = q.options_abc.concat(q.options_pqr);
          obj.options.map(o => {
            delete o["id"];
            delete o["question_id"];
          });
        } else if (q.questionType.id === this.questionTypes.MATRIX_MATCH_OPTION) {
          obj.options = q.options.concat(q.options_abc).concat(q.options_pqr);
          obj.options.map(o => {
            delete o["id"];
            delete o["question_id"];
          });
        }

        list.push(obj);

        stepOneData.testName = this.testDetails.test_name;
        stepOneData.duration = this.testDetails.duration;
        stepOneData.selectedTarget = this.testDetails.target;
        stepOneData.testId = this.testDetails.id;
        stepOneData.testType = this.testDetails.test_type;

        let reqData = {
          list: list,
          target: stepOneData.selectedTarget,
          test_type: stepOneData.testType ? stepOneData.testType : this.TEST_TYPE.CUSTOM,
          duration: stepOneData.duration,
          test_name: stepOneData.testName,
          instructions: this.instructions,
          only_question: true,
          isEditable: true,
        };

        if (stepOneData.testId) {
          reqData.id = stepOneData.testId;
          reqData.test_id = stepOneData.testId
        }

        this.createTest(reqData)
          .then(response => {
            this.$root.showLoader = false;
            this.$toasted.success(`Success\n${response.msg}`, {
              icon: "check_circle",
            });
            this.isEditing = false;
            if (
              response.details.question_type === this.questionTypes.COMPREHENSION ||
              response.details.question_type === this.questionTypes.TC
            ) {
              this.requestGetTestDetails();
            } else {
              this.updateCurrentQuestions(
                this.currentQuestionToBeEdited,
                response.details
              );
            }

            this.scrollToTop();
          })
          .catch(err => {
            this.$root.showLoader = false;
          });
      }
    },

    //
    updateCurrentQuestions(q, qDetails) {
      this.currentQuestion.question_text = q.question_text;
      this.currentQuestion.solution = q.solution;
      this.currentQuestion.solution = q.solution.replace(/equation-class/gi,'equation');
      this.currentQuestion.hints = q.hints;
      this.currentQuestion.topic_id = q.topic_id;
      this.currentQuestion.topicName = q.topicName
        ? q.topicName
        : q.topic
        ? q.topic.title
        : "";
      //   this.currentQuestion.subtopic = qDetails.subtopic;

      this.currentQuestion.subtopic_id = q.subtopic_id;
      this.currentQuestion.subtopicName = q.subtopicName
        ? q.subtopicName
        : q.subtopic
        ? q.subtopic.title
        : "";
      //   this.currentQuestion.concept = q.concept;

      this.currentQuestion.concept_id = q.concept_id;
      this.currentQuestion.conceptName = q.conceptName
        ? q.conceptName
        : q.concept
        ? q.concept.title
        : "";
      //   this.currentQuestion.datatype =q.datatype;

      this.currentQuestion.chapterId = q.chapterId ? q.chapterId : q.data_type_id;
      this.currentQuestion.chapterName = q.chapterName
        ? q.chapterName
        : q.datatype
        ? q.datatype.title
        : "";
      this.currentQuestion.difficultyName = q.difficultyName
        ? q.difficultyName
        : this.difficulty.find(d => d.id === q.difficulty_level).title || "";
      this.currentQuestion.difficultyId = q.difficultyId
        ? q.difficultyId
        : this.difficulty.find(d => d.id === q.difficulty_level).id || 0;
      this.currentQuestion.difficulty_level = q.difficultyId
        ? q.difficultyId
        : this.difficulty.find(d => d.id === q.difficulty_level).id || 0;
      this.currentQuestion.institute_id = !q.institute_id ? null : q.institute_id;
      (this.currentQuestion.answer_type = q.answer_type
        ? q.answer_type
        : q.answertype
        ? q.answertype.id
        : null),
        (this.currentQuestion.skillsetName = qDetails.skillsetName
          ? qDetails.skillsetName
          : qDetails.answertype
          ? qDetails.answertype.value
          : null);
      this.currentQuestion.question_view_count = 0;
      this.currentQuestion.last_created_at = null;
      let questionsToBeUpdated = null;
      let editedSubquestion = null;
      switch (this.currentQuestion.question_type) {
        case this.questionTypes.INTEGER:
          this.currentQuestion.correct_answer = q.correct_answer;
          break;

        case this.questionTypes.MATRIX_MATCH:
          this.currentQuestion.options_abc = qDetails.options.filter(o => o.column == 1);
          this.currentQuestion.options_pqr = qDetails.options.filter(o => o.column == 2);
          // this.currentQuestion.options_abc = q.options_abc;
          // this.currentQuestion.options_pqr = q.options_pqr;
          break;

        case this.questionTypes.MATRIX_MATCH_OPTION:
          this.currentQuestion.options_abc = qDetails.options.filter(o => o.column == 1);
          this.currentQuestion.options_pqr = qDetails.options.filter(o => o.column == 2);
          this.currentQuestion.options = qDetails.options.filter(o => o.column == null);
          // this.currentQuestion.options_abc = q.options_abc;
          // this.currentQuestion.options_pqr = q.options_pqr;
          // this.currentQuestion.options = q.options;
          break;

        case this.questionTypes.COMPREHENSION:
          questionsToBeUpdated = this.questions.filter(qt => qt.parent_id == q.parent_id);
          editedSubquestion = q.questions[0];
          questionsToBeUpdated.forEach(ques => {
            ques.passage = q.question_text;
            if (ques.id == editedSubquestion.id) {
              ques.question_text = editedSubquestion.question_text;
              ques.options = editedSubquestion.options;
            }
          });
          break;

        case this.questionTypes.TC:
          questionsToBeUpdated = this.questions.filter(qt => qt.parent_id == q.parent_id);
          editedSubquestion = q.questions[0];
          questionsToBeUpdated.forEach(ques => {
            ques.passage = q.question_text;
            if (ques.id == editedSubquestion.id) {
              ques.question_text = editedSubquestion.question_text;
              ques.options = editedSubquestion.options;
            }
          });
          break;

        case this.questionTypes.SUBJECTIVE:
        case this.questionTypes.SUBJECTIVEINTEGER:
          this.currentQuestion.correct_answer = q.correct_answer;
          if (
            q.questionType.id === this.questionTypes.SUBJECTIVE ||
            q.questionType.id === this.questionTypes.SUBJECTIVEINTEGER
          ) {
            this.currentQuestion.startValue = q.startValue;
            this.currentQuestion.endValue = q.endValue;
          }
          break;

        case this.questionTypes.ASSERTION_REASON:
          this.currentQuestion.options = q.options;
          break;

        case this.questionTypes.MULTIPLE_CORRECT:
          this.currentQuestion.options = q.options;
          break;

        case this.questionTypes.SINGLE_CORRECT:
        case this.questionTypes.SINGLE_CORRECT_SEC2:
          this.currentQuestion.options = q.options;
          break;
      }
      this.renderMathData();
      this.renderMathData();
    },
    updateSearchAnotherQuestion(q, qDetails) {
      this.currentQuestion.id = qDetails.id;
      this.currentQuestion.parent_id = qDetails.parent_id;
      this.currentQuestion.question_text = qDetails.question_text;
      this.currentQuestion.passage = qDetails.passage ? qDetails.passage : "";
      this.currentQuestion.solution = qDetails.solution;
      this.currentQuestion.solution = qDetails.solution.replace(/equation-class/gi,'equation');
      this.currentQuestion.hints = qDetails.hints;
      this.currentQuestion.topic = qDetails.topic;
      this.currentQuestion.topic_id = qDetails.topic_id;
      this.currentQuestion.topicName = qDetails.topicName
        ? qDetails.topicName
        : qDetails.topic
        ? qDetails.topic.title
        : "";
      this.currentQuestion.subtopic = qDetails.subtopic;

      this.currentQuestion.subtopic_id = qDetails.subtopic_id;
      this.currentQuestion.subtopicName = qDetails.subtopicName
        ? qDetails.subtopicName
        : qDetails.subtopic
        ? qDetails.subtopic.title
        : "";
      this.currentQuestion.concept = qDetails.concept;

      this.currentQuestion.concept_id = qDetails.concept_id;
      this.currentQuestion.conceptName = qDetails.conceptName
        ? qDetails.conceptName
        : qDetails.concept
        ? qDetails.concept.title
        : "";
      this.currentQuestion.datatype = qDetails.datatype;

      this.currentQuestion.chapterId = qDetails.chapterId
        ? qDetails.chapterId
        : qDetails.data_type_id;
      this.currentQuestion.chapterName = qDetails.chapterName
        ? qDetails.chapterName
        : qDetails.datatype
        ? qDetails.datatype.title
        : "";
      this.currentQuestion.difficultyName = qDetails.difficultyName
        ? qDetails.difficultyName
        : qDetails.difficulty_level
        ? this.difficulty.find(d => d.id === qDetails.difficulty_level).title
        : "";
      this.currentQuestion.difficultyId = qDetails.difficultyId
        ? qDetails.difficultyId
        : qDetails.difficulty_level
        ? this.difficulty.find(d => d.id === qDetails.difficulty_level).id
        : 0;
      this.currentQuestion.difficulty_level = qDetails.difficultyId
        ? qDetails.difficultyId
        : qDetails.difficulty_level
        ? this.difficulty.find(d => d.id === qDetails.difficulty_level).id
        : 0;
      this.currentQuestion.institute_id = !qDetails.institute_id
        ? null
        : qDetails.institute_id;
      (this.currentQuestion.answer_type = qDetails.answer_type
        ? qDetails.answer_type
        : qDetails.answertype
        ? qDetails.answertype.id
        : null),
        (this.currentQuestion.skillsetName = qDetails.skillsetName
          ? qDetails.skillsetName
          : qDetails.answertype
          ? qDetails.answertype.value
          : null);
      this.currentQuestion.question_view_count = qDetails.question_view_count;
      this.currentQuestion.last_created_at = qDetails.last_created_at
        ? moment(qDetails.last_created_at).format(constants.DATE_FORMATS.DISPLAY_DATE)
        : null;
        this.currentQuestion.tags = qDetails.tags;
        this.currentQuestion.historyDetails = [];
            qDetails.history_of_question &&
              qDetails.history_of_question.length &&
              qDetails.history_of_question.map(c => {
                this.currentQuestion.historyDetails.push({
                  testScheduleDate: c.last_created_at
                    ? moment(c.last_created_at).format(
                        constants.DATE_FORMATS.DISPLAY_DATE
                      )
                    : "",
                  testCenterName: c.center_name ? c.center_name : "",
                  testBatchName: c.batch_name ? c.batch_name : "",
                });
              });
              if (qDetails && qDetails.historyDetails && qDetails.historyDetails.length) {
                this.currentQuestion.historyDetails = qDetails.historyDetails;
              }
      this.showTags = false;
      this.$forceUpdate();
      let questionsToBeUpdated = null;
      let editedSubquestion = null;
      this.currentQuestion.question_bucket_count = qDetails.question_bucket_count
        ? qDetails.question_bucket_count
        : 0;
      switch (this.currentQuestion.question_type) {
        case this.questionTypes.INTEGER:
          this.currentQuestion.correct_answer = qDetails.correct_answer;
          break;

        case this.questionTypes.MATRIX_MATCH:
          if (qDetails.options && qDetails.options.length) {
            this.currentQuestion.options_abc = qDetails.options.filter(
              o => o.column == 1
            );
            this.currentQuestion.options_pqr = qDetails.options.filter(
              o => o.column == 2
            );
          } else {
            this.currentQuestion.options_abc = qDetails.options_abc;
            this.currentQuestion.options_pqr = qDetails.options_pqr;
          }

          // this.currentQuestion.options_abc = q.options_abc;
          // this.currentQuestion.options_pqr = q.options_pqr;
          break;

        case this.questionTypes.MATRIX_MATCH_OPTION:
          this.currentQuestion.options_abc = qDetails.options.filter(o => o.column == 1);
          this.currentQuestion.options_pqr = qDetails.options.filter(o => o.column == 2);
          this.currentQuestion.options = qDetails.options.filter(o => o.column == null);
          // this.currentQuestion.options_abc = q.options_abc;
          // this.currentQuestion.options_pqr = q.options_pqr;
          // this.currentQuestion.options = q.options;
          break;

        case this.questionTypes.COMPREHENSION:
          // questionsToBeUpdated = this.questions.filter(
          //   (qt) => qt.parent_id == qDetails.parent_id
          // );
          // editedSubquestion = qDetails;
          // questionsToBeUpdated.forEach((ques) => {
          //   ques.passage = qDetails.question_text;
          //   if (ques.id == editedSubquestion.id) {
          //     ques.question_text = editedSubquestion.question_text;
          //     ques.options = editedSubquestion.options;
          //   }
          // });
          this.currentQuestion.options = qDetails.options;

          break;

        case this.questionTypes.TC:
          // questionsToBeUpdated = this.questions.filter(
          //   (qt) => qt.parent_id == qDetails.parent_id
          // );
          // //   editedSubquestion = qDetails.questions[0];
          // //   questionsToBeUpdated.forEach((ques) => {
          // //     ques.passage = qDetails.question_text;
          // //     if (ques.id == editedSubquestion.id) {
          // //       ques.question_text = editedSubquestion.question_text;
          // //       ques.options = editedSubquestion.options;
          // //     }
          // //   });
          // editedSubquestion = qDetails;

          // questionsToBeUpdated.forEach((ques) => {
          //   ques.passage = qDetails.question_text;
          //   if (ques.id == editedSubquestion.id) {
          //     ques.question_text = editedSubquestion.question_text;
          //     ques.options = editedSubquestion.options;
          //   }
          // });
          this.currentQuestion.options = qDetails.options;

          break;

        case this.questionTypes.SUBJECTIVE:
        case this.questionTypes.SUBJECTIVEINTEGER:
          this.currentQuestion.correct_answer = qDetails.correct_answer;
          if (
            qDetails.question_type === this.questionTypes.SUBJECTIVE ||
            q.questionType.id === this.questionTypes.SUBJECTIVEINTEGER
          ) {
            if (qDetails.startValue && qDetails.endValue) {
              this.currentQuestion.startValue = qDetails.startValue;
              this.currentQuestion.endValue = qDetails.endValue;
            } else {
              let answerArray = qDetails.correct_answer.split("##");
              if (answerArray.length == 2) {
                this.currentQuestion.startValue = answerArray[0];
                this.currentQuestion.endValue = answerArray[1];
              }
            }
          }
          break;

        case this.questionTypes.ASSERTION_REASON:
          this.currentQuestion.options = qDetails.options;
          break;

        case this.questionTypes.MULTIPLE_CORRECT:
          this.currentQuestion.options = qDetails.options;
          break;

        case this.questionTypes.SINGLE_CORRECT:
        case this.questionTypes.SINGLE_CORRECT_SEC2:
          this.currentQuestion.options = qDetails.options;
          break;
      }
      this.renderMathData();
      this.renderMathData();
    },
    showAllQuestions() {
      this.alertBoxData = {};
      this.alertBoxData.subjectQuestionTypeList = [];
      let subjectQuestionTypeList = this.subjectQuestionTypeList;
      subjectQuestionTypeList.forEach(sqt => {
        let sqtObj = Object.assign({}, sqt);
        sqtObj.showAnswerField = false;
        this.alertBoxData.subjectQuestionTypeList.push(sqtObj);
      });
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent = "components/PreviewTest/QuestionPaper";
      this.$forceUpdate();
    },
    renderMathData() {
      this.renderMath();
    },
    getLegendsData(index) {
      this.legendsData = {
        answered: 0,
        reviewLater: 0,
        answeredReviewLater: 0,
        notVisited: 0,
        notAnswered: 0,
        easy: 0,
        moderate: 0,
        tough: 0,
      };
      let questions = [];
      if (index != null) {
        questions = this.subjectQuestionTypeList[index].questions;
      } else {
        questions = Object.values(this.filteredQuestionsList);
      }
      questions.forEach(val => {
        if (val.status == this.questionStatus.ANSWER_SELECTED_SAVED) {
          this.legendsData.answered++;
        }
        if (val.status == this.questionStatus.ANSWER_NOT_SELECTED_REVIEW) {
          this.legendsData.reviewLater++;
        }
        if (val.status == this.questionStatus.ANSWER_SELECTED_REVIEW) {
          this.legendsData.answeredReviewLater++;
        }
        if (val.status < this.questionStatus.VISITED) {
          this.legendsData.notVisited++;
        }
        if (
          (val.status == this.questionStatus.VISITED && !val.isAnswered) ||
          val.status == this.questionStatus.ANSWER_NOT_SELECTED_SAVED
        ) {
          this.legendsData.notAnswered++;
        }
        if (val.difficulty_level === this.difficulty[0].id) {
          this.legendsData.easy++;
        }
        if (val.difficulty_level === this.difficulty[1].id) {
          this.legendsData.moderate++;
        }
        if (val.difficulty_level === this.difficulty[2].id) {
          this.legendsData.tough++;
        }

        if (val.difficulty_level === null && val.institute_id) {
          this.legendsData.moderate++;
        }
      });
    },
    getQuestionData() {
      this.questionData = this.subjectQuestionTypeList[this.selectedSQTIndex];
      this.questions = this.questionData.questions;
      this.scrollQtypeValue = 1;
      this.saveCurrentAction("nextQuestion");
      this.getChapters(
        this.questionData.questions[0].datatype.parentDetails.id,
        this.questionData.questions[0].sub_subject
      );
    },
    async clearReponse() {
      let unable = false;
      this.expansionPanelStatus = null;
      this.currentQuestion.status = this.questionStatus.VISITED;
      this.currentQuestion.isAnswered = false;
      if (this.currentQuestion.isAnswered) {
        unable = true;
      }
      this.currentQuestion.isAnswered = false;
      if (unable) {
        console.log("enabling answers because of mandatory questions");

        this.questions.map(q => {
          if (!q.isAnswered) {
            q.isAnswerDisabled = false;
          }
        });
      }

      let currentQuestionType = this.currentQuestion.question_type;
      if (
        currentQuestionType == this.questionTypes.TC ||
        currentQuestionType == this.questionTypes.COMPREHENSION
      ) {
        currentQuestionType = this.currentQuestion.subtype;
      }
      let type = await this.getQuestionType(currentQuestionType);

      if (!this.isPreview) {
        this.endAction = this.QUESTION_ACTIONS.CLEAR;
        this.saveCurrentAction("clearQuestion");
      }
      this.scrollToTop();
      switch (type) {
        case 1:
          this.currentQuestion.options = this.currentQuestion.options.map(opt => {
            opt.correct_answer = false;
            return opt;
          });
          break;
        case 2:
          this.currentQuestion.correct_answer = "";
          break;
        case 3:
          this.currentQuestion.options_abc = this.currentQuestion.options_abc.map(opt => {
            opt.correct_answer = "";
            return opt;
          });
          break;
        case 4:
          this.currentQuestion.options = this.currentQuestion.options.map(opt => {
            opt.correct_answer = false;
            return opt;
          });
          break;
        case 5:
          let subQuestions = this.currentQuestion.questions;
          subQuestions.forEach(sq => {
            sq.options = sq.options.map(q => {
              q.correct_answer = false;
              return q;
            });
          });
          break;
        case 6:
          this.currentQuestion.correct_answer = "";
          this.currentQuestion.startValue = null;
          this.currentQuestion.endValue = null;
          break;
      }
      this.setFullScreen();
      this.setDisableSecondaryAction(false);
    },
    async updateQuestionStatus(ansStatus) {
      this.setDisableSecondaryAction(false);
      this.isAnswerBtnClicked = true;
      !this.isPreview ? this.setFullScreen() : "";
      let currentQuestionStatus = this.currentQuestion.status;
      let isAnswered = this.currentQuestion.isAnswered;
      let newStatus = currentQuestionStatus;

      if (isAnswered) {
        if (ansStatus == this.QUESTION_ACTIONS.SUBMIT) {
          newStatus = this.questionStatus.ANSWER_SELECTED_SAVED;
          this.endAction = this.QUESTION_ACTIONS.SUBMIT;
          this.questionAnsweredCount = this.questionData.qAnsweredCount + 1;
        }
        if (ansStatus == this.QUESTION_ACTIONS.REVIEW_LATER) {
          newStatus = this.questionStatus.ANSWER_SELECTED_REVIEW;
          this.endAction = this.QUESTION_ACTIONS.ANSWER_REVIEW_LATER;
          this.questionAnsweredCount = this.questionData.qAnsweredCount + 1;
        }
      } else {
        if (ansStatus == this.QUESTION_ACTIONS.SUBMIT) {
          newStatus = this.questionStatus.ANSWER_NOT_SELECTED_SAVED;
          this.endAction = this.QUESTION_ACTIONS.NEXT;
        }
        if (ansStatus == this.QUESTION_ACTIONS.REVIEW_LATER) {
          newStatus = this.questionStatus.ANSWER_NOT_SELECTED_REVIEW;
          this.endAction = this.QUESTION_ACTIONS.REVIEW_LATER;
        }
      }

      this.currentQuestion.status = newStatus;
      this.nextQuestionIndex = this.questionData.currentQuestionIndex + 1;
      this.showNextQuestion = true;
      this.scrollQtypeValue = null;
      this.saveCurrentAction("currentQuestion");
    },

    getPostData(type) {
      return [
        {
          activity: this.QUESTION_ACTIVITY.STOP,
          entity: "",
          entity_id: 0,
        },
        {
          activity: this.QUESTION_ACTIVITY.START,
          entity: "",
          entity_id: 0,
        },
      ];
    },
    getUpdateProgressPostData(type) {
      let postData = [
        {
          activity: this.QUESTION_ACTIVITY.STOP,
          entity: "",
          entity_id: 0,
        },
        {
          activity: this.QUESTION_ACTIVITY.START,
          entity: "",
          entity_id: 0,
        },
      ];
      if (type == "currentQuestion") {
        return [postData[0]];
      } else if (type == "nextQuestion") {
        return [postData[1]];
      } else if (
        type == "firstQuestion" ||
        type == "lastQuestion" ||
        type == "clearQuestion"
      ) {
        return postData;
      }
    },
    saveCurrentAction(type) {
      // let currentQuestion = this.currentQuestion;
      if (this.isPreview) {
        // this.currentQuestion = this.questions[];
        this.nextQuestion();
      } else {
        this.updateCurrentAction(type);
      }
    },
    updateCurrentAction(questionStatus) {
      let cq = this.currentQuestion;
      let callApi = false;
      let postData = this.getUpdateProgressPostData(questionStatus);
      let p1 = postData[0];
      let p2 = null;
      let defaultActions = [
        this.QUESTION_ACTIONS.NEXT,
        this.QUESTION_ACTIONS.SUBMIT,
        this.QUESTION_ACTIONS.REVIEW_LATER,
        this.QUESTION_ACTIONS.ANSWER_REVIEW_LATER,
        this.QUESTION_ACTIONS.JUMP,
      ];
      let tabChanged = sessionStorage.getItem("changedTab");
      this.noOfTimesTabChanged = tabChanged
        ? parseInt(this.decryptString(tabChanged))
        : 0;
      if (defaultActions.includes(this.endAction) && cq.id) {
        if (cq) {
          callApi = true;
          p1.activity = this.QUESTION_ACTIVITY.STOP;
          p1.entity = this.QUESTION_ENTITY.QUESTION;
          p1.index = 0;
          p1.test_detail_id = cq.test_detail_id;
          p1.entity_id = cq.id;
          p1.section_id = cq.section_id;
          p1.end_action = this.endAction;
          p1.answer = {
            status: cq.status,
            answer: this.getAnswerAsPerType(cq),
          };
        }
      } else if (this.endAction == this.QUESTION_ACTIONS.TEST_STARTED) {
        if (cq) {
          callApi = true;
          p1.activity = this.QUESTION_ACTIVITY.START;
          p1.entity = this.QUESTION_ENTITY.TEST;
          p1.entity_id = this.testDetails.id;
        }
      } else if (this.endAction == this.QUESTION_ACTIONS.NEXT_QUESTION) {
        if (cq) {
          callApi = true;

          p1.activity = this.QUESTION_ACTIVITY.START;
          p1.entity = this.QUESTION_ENTITY.QUESTION;
          p1.index = 0;
          p1.entity_id = cq.id;
          p1.test_detail_id = cq.test_detail_id;
          p1.noOfTimesTabChanged = this.noOfTimesTabChanged;
          p1.section_id = cq.section_id;
        }
      } else if (this.endAction == this.QUESTION_ACTIONS.FINISH_TEST) {
        if (cq) {
          callApi = true;
          p1.activity = this.QUESTION_ACTIVITY.STOP;
          p1.entity = this.QUESTION_ENTITY.QUESTION;
          p1.index = 0;
          p1.entity_id = cq.id;
          p1.test_detail_id = cq.test_detail_id;
          p1.section_id = cq.section_id;
          p1.isAutoFinished = this.testAutoFinished;
          p1.noOfTimesTabChanged = this.noOfTimesTabChanged;
          p1.answer = {
            status: cq.status,
            answer: this.getAnswerAsPerType(cq),
          };
          p1.end_action = this.QUESTION_ACTIONS.END_TEST;
        }
      } else if (this.endAction == this.QUESTION_ACTIONS.CLEAR) {
        if (cq) {
          callApi = true;
          postData.push(_.cloneDeep(p1));
          postData.push(_.cloneDeep(p1));
          p2 = postData[1]; // start clear response
          let p3 = postData[2]; // stop clear respone
          let p4 = postData[3]; // start the same question again

          p1.activity = this.QUESTION_ACTIVITY.STOP; // stop the current question
          p1.entity = this.QUESTION_ENTITY.QUESTION;
          p1.index = 0;
          p1.test_detail_id = cq.test_detail_id;
          p1.entity_id = cq.id;
          p1.section_id = cq.section_id;
          p1.end_action = this.endAction;
          p1.answer = {
            status: cq.status,
            answer: this.getAnswerAsPerType(cq),
          };

          p2.activity = this.QUESTION_ACTIVITY.START;
          p2.entity = this.QUESTION_ENTITY.QUESTION;
          p2.index = 0;
          p2.test_detail_id = cq.test_detail_id;
          p2.entity_id = cq.id;
          p2.section_id = cq.section_id;
          p2.end_action = this.endAction;
          p2.answer = {
            status: cq.status,
            answer: null,
          };

          p3.activity = this.QUESTION_ACTIVITY.STOP;
          p3.entity = this.QUESTION_ENTITY.QUESTION;
          p3.index = 0;
          p3.test_detail_id = cq.test_detail_id;
          p3.entity_id = cq.id;
          p3.section_id = cq.section_id;
          p3.end_action = this.endAction;

          p4.activity = this.QUESTION_ACTIVITY.START;
          p4.entity = this.QUESTION_ENTITY.QUESTION;
          p4.index = 0;
          p4.entity_id = cq.id;
          p4.test_detail_id = cq.test_detail_id;
          p4.section_id = cq.section_id;
        }
      } else if (this.endAction == this.QUESTION_ACTIONS.LAST_QUESTION) {
        if (cq) {
          callApi = true;

          p1.activity = this.QUESTION_ACTIVITY.START;
          p1.entity = this.QUESTION_ENTITY.QUESTION;
          p1.index = 0;
          p1.entity_id = cq.id;
          p1.test_detail_id = cq.test_detail_id;
          p1.section_id = cq.section_id;
          p1.noOfTimesTabChanged = this.noOfTimesTabChanged;
        }
      } else if (this.endAction == this.QUESTION_ACTIONS.FINISH_TEST_ERROR) {
        // if (cq) {
        callApi = true;
        p1.activity = this.QUESTION_ACTIVITY.STOP;
        p1.entity = this.QUESTION_ENTITY.QUESTION;
        p1.index = 0;
        p1.entity_id = cq ? cq.id : -1;
        p1.test_detail_id = cq ? cq.test_detail_id : -1;
        p1.section_id = cq ? cq.section_id : -1;
        p1.noOfTimesTabChanged = this.noOfTimesTabChanged;
        p1.answer = {
          status: cq ? cq.status : -1,
          answer: this.finishTestError,
        };
        p1.end_action = this.QUESTION_ACTIONS.FINISH_TEST_ERROR;
        // }
      } else if (this.endAction == this.QUESTION_ACTIONS.END_TEST) {
        // if (cq) {
        callApi = true;
        (p1.activity = this.QUESTION_ACTIVITY.STOP),
          (p1.entity = this.QUESTION_ENTITY.TEST),
          (p1.entity_id = this.testDetails.id),
          (p1.isAutoFinished = this.testData.isAutoFinished);
        p1.end_action = this.QUESTION_ACTIONS.END_TEST;
        p1.noOfTimesTabChanged = this.noOfTimesTabChanged;
        // }
      }

      if (callApi) this.updateProgress(postData);
    },

    updateProgress(data) {
      this.$root.showLoader = true;
      let postData = {
        test_institute_id: this.testDetails ? this.testDetails.test_institute_id : -1,
        test_schedule_id: this.testDetails ? this.testDetails.test_schedule_id : -1,
        actions: data,
        system_info: {
          browser_name: this.$device.client.name,
          system_name: this.$device.device.type,
          os_name: this.$device.os_name.name,
          brower_details: {
            name: this.$device.client.name,
            version: this.$device.client.version,
          },
          device_details: this.$device.machine,
        },
      };

      this.updateProgressInDB(postData)
        .then(response => {
          this.expansionPanelStatus = null;
          if (this.showNextQuestion) {
            this.nextQuestion();
          }
          if (this.endAction == this.QUESTION_ACTIONS.FINISH_TEST) {
            this.gotoSummary();
          }
          if (this.endAction == this.QUESTION_ACTIONS.CLEAR) {
            this.showTimer = true;
          }
          if (this.endAction == this.QUESTION_ACTIONS.END_TEST) {
            sessionStorage.removeItem("changedTab");
            this.setIsTestStarted(false);
            this.redirectAsType();
          }
          this.$root.showLoader = false;
        })
        .catch(err => {
          if (!navigator.onLine) {
            this.$toasted.error(
              "Error Updating status. Please check your internet connection and try again."
            );
          }
          let errObj = "";
          if (err && err.data && err.data.errors) {
            errObj = err.data.errors;
          } else if (err && err.data) {
            errObj = err.data;
          } else {
            errObj = err;
          }
          let error_log = new Error(`
          **UPDATE_PROGRESS**LIVE_ST::${this.user.id}:${
            this.testDetails.test_schedule_id
          },
          payload:${JSON.stringify(postData)}, 
          api:'update-progress', 
          error:${JSON.stringify(errObj)},
          networkStatus: ${navigator.onLine}, 
          user_id: ${this.user.id}`);
          this.sendLogData(errObj, "update-progress", "live-test-api", postData);

          this.showTimer = true;
          this.$root.showLoader = false;
          this.isAnswerBtnClicked = false;
          if (err.data && err.data.errors) {
            err.data.errors.forEach(e => {
              if (
                e.code == this.ERROR_CODES.TIMEOUTERROR ||
                e.code == this.ERROR_CODES.TESTNOTACTIVE
              ) {
                this.autoSubmitError = e.code;
                this.autoSubmitEndAction = "update-progress";
                let LogData = new Error(`
                user_id: ${this.user.id.toString()},
                test_id: ${
                  this.testDetails && this.testDetails.id
                    ? this.testDetails.id.toString()
                    : "Not Found"
                },
                event_name: ${e.code},
                time: ${moment().format("YYYY-MM-DD HH:mm:ss.SSS").toString()}`);

                this.autoSubmitTestData();
                this.setIsTestStarted(false);
                this.redirectAsType();
              }
            });
          }
        });
    },
    setCurrentQuestions() {
      this.isSQTChanged = false;
      this.questionData = this.subjectQuestionTypeList[this.selectedSQTIndex];
      this.questions = this.questionData.questions;
      this.getChapters(
        this.questionData.questions[0].datatype.parentDetails.id,
        this.questionData.questions[0].sub_subject
      );
      this.isApiCall = false;
    },
    nextQuestion() {
      this.isCallBucketApi = true;
      this.expansionPanelStatus = null;
      sessionStorage.removeItem("selectedQuestionIds");
      localStorage.removeItem("searchedQuestion");
      localStorage.removeItem("currentQuestion");
      // if subject question type is changed need to change the set of questions as selected type
      if (this.isSQTChanged) {
        this.setCurrentQuestions();
      }
      let count = 0;
      this.questions.map(q => {
        if (q.isAnswered) {
          count = count + 1;
        }
      });
      if (
        this.questionData.mandatoryQuestions &&
        this.questionData.mandatoryQuestions.allow_all === 0
      ) {
        if (count === this.questionData.mandatoryQuestions.mandatory_questions) {
          console.log("disabling answers because of mandatory questions", {
            count,
            mandatoryQuestion: this.questionData.mandatoryQuestions,
          });
          this.questionData.questions.map(m => {
            if (!m.isAnswered) {
              m.isAnswerDisabled = true;
            }
          });
          // 	let nextSubjectQuestionTypeIndex = this.selectedSQTIndex + 1;
          // 	                    let nextType = this.subjectQuestionTypeList[
          //     nextSubjectQuestionTypeIndex
          // ];
          // 	this.setCurrentQuestionData(
          // 		nextSubjectQuestionTypeIndex,
          // 		nextType.currentQuestionIndex
          // 	);
          // this.nextQuestionIndex = nextType.currentQuestionIndex;
          // this.questionAnsweredCount = nextType.qAnsweredCount;
          // this.setCurrentQuestions();
        } else {
          console.log("enabling answers because of mandatory questions");
          this.questionData.questions.map(m => {
            m.isAnswerDisabled = false;
          });
        }
      }

      if (this.nextQuestionIndex == this.questions.length) {
        let nextSubjectQuestionTypeIndex = this.selectedSQTIndex + 1;
        if (nextSubjectQuestionTypeIndex < this.subjectQuestionTypeList.length) {
          let nextType = this.subjectQuestionTypeList[nextSubjectQuestionTypeIndex];

          this.setCurrentQuestionData(
            nextSubjectQuestionTypeIndex,
            nextType.currentQuestionIndex
          );
          this.nextQuestionIndex = nextType.currentQuestionIndex;
          this.questionAnsweredCount = nextType.qAnsweredCount;
          this.setCurrentQuestions();
        } else {
          if (!this.isPreview) {
            this.endAction = this.QUESTION_ACTIONS.LAST_QUESTION;
            this.showNextQuestion = false;
            this.saveCurrentAction("nextQuestion");
          }
          this.isAnswerBtnClicked = false;
          this.showTimer = true;
          this.scrollToTop();
          return;
        }
      }
      // else {
      let typeIndex = this.selectedSQTIndex;
      this.setSelectedQuestionIndex({
        currentQuestionIndex: this.nextQuestionIndex,
        typeIndex,
      });
      this.setAnswerCount({
        qAnsweredCount: this.questionAnsweredCount,
        typeIndex,
      });

      this.currentQuestion = this.questions[this.nextQuestionIndex];
      this.$nextTick(() => {
        if (this.currentQuestion.status == this.questionStatus.INITIAL)
          this.currentQuestion.status = this.questionStatus.VISITED;
      });
      if (!this.isPreview) {
        this.showNextQuestion = false;
        this.endAction = this.QUESTION_ACTIONS.NEXT_QUESTION;
        this.saveCurrentAction("nextQuestion");
      }
      let storeCurrentQuestionCookie = {
        currentSQTIndex: this.selectedSQTIndex,
        currentQuestionIndex: this.nextQuestionIndex,
        userId: this.user.id,
        testId: this.$route.params.test_id,
        testInstituteId: this.$route.params.test_institute_id,
      };
      this.$cookies.set("CATAPULT_TEST", storeCurrentQuestionCookie);
      // }
      if (this.currentQuestion) {
        this.slectedChapter = {
          chapter_id: this.currentQuestion.chapterId,
          title: this.currentQuestion.chapterName,
        };
        this.getTopics(this.slectedChapter.chapter_id);
      }
      if (this.currentQuestion) {
        this.selectedTopic = {
          topic_id: this.currentQuestion.topic_id,
          title: this.currentQuestion.topicName,
        };
        this.getSubTopics(this.currentQuestion.topic_id);
      }
      if (this.currentQuestion) {
        this.selectedDifficultyLevel = {
          id: this.currentQuestion.difficultyId,
          title: this.currentQuestion.difficultyName,
        };
      }
      if (this.currentQuestion) {
        this.selectedSkillSet = {
          id: this.currentQuestion.answer_type,
          title: this.currentQuestion.skillsetName,
        };
        //this.getSkillSets(this.currentQuestion.answer_type)
      }
      if (this.currentQuestion) {
        this.selectedSubTopic = {
          subtopic_id: this.currentQuestion.subtopic_id,
          title: this.currentQuestion.subtopicName,
        };
        this.getConcepts(this.currentQuestion.subtopic_id);
      }
      if (this.currentQuestion) {
        this.selectedConcept = {
          concept_id: this.currentQuestion.concept_id,
          title: this.currentQuestion.conceptName,
        };
        //this.getSubTopics(this.currentQuestion.topic_id)
      }

      this.scrollToTop();
      // this.renderMath();
      setTimeout(async()=>await this.renderMath(),100);
      this.isAnswerBtnClicked = false;
      this.showTimer = true;

      if (this.scrollQtypeValue !== 1) {
        this.$refs.carousel.currentPage = this.$refs.carousel.scrollPerPage
          ? Math.round(
              this.$refs.carousel.offset /
                this.$refs.carousel.slideWidth /
                this.$refs.carousel.currentPerPage
            )
          : Math.round(this.$refs.carousel.offset / this.$refs.carousel.slideWidth);

        // this.$refs.carousel.goToPage(
        //     this.selectedSQTIndex + 1,
        //     "pagination"
        // );
        this.navigateTo = this.selectedSQTIndex;
      }
      this.showTags = false;
      this.updateStatus();
      if (this.isPreview) {
        this.getQuestionInfo();
      }
    },
    getAnswerAsPerType(q) {
      let answer = null;
      let selectedOption = null;
      let options = null;
      let questionType =
        q.question_type == this.questionTypes.COMPREHENSION ||
        q.question_type == this.questionTypes.TC
          ? q.subtype
          : q.question_type;

      if (
        questionType == this.questionTypes.TC_2Q_SA ||
        questionType == this.questionTypes.TC_3Q_SA ||
        questionType == this.questionTypes.COMPREHENSION_3Q_SA ||
        questionType == this.questionTypes.COMPREHENSION_2Q_SA ||
        questionType == this.questionTypes.COMPREHENSION_2Q_MM
      ) {
        questionType = this.questionTypes.SINGLE_CORRECT;
      } else if (
        questionType == this.questionTypes.COMPREHENSION_3Q_MA ||
        questionType == this.questionTypes.COMPREHENSION_2Q_MA
      ) {
        questionType = this.questionTypes.MULTIPLE_CORRECT;
      }
      switch (questionType) {
        case this.questionTypes.INTEGER:
          answer = q.correct_answer;
          break;

        case this.questionTypes.MATRIX_MATCH:
          options = [];
          q.options_abc.map((o, idx) => {
            if (o.correct_answer > "") {
              options.push({
                option_id: o.id,
                value: o.correct_answer,
              });
            }
          });
          answer = options.length > 0 ? options : null;
          break;

        case this.questionTypes.MATRIX_MATCH_OPTION:
          selectedOption = q.options.find(option => option.correct_answer == true);
          answer = selectedOption ? { option_id: selectedOption.id } : null;
          break;

        case this.questionTypes.SUBJECTIVE:
        case this.questionTypes.SUBJECTIVEINTEGER:
        case this.questionTypes.COMPREHENSION_2Q_NU:
          answer = {};
          answer = q.correct_answer;
          break;

        case this.questionTypes.ASSERTION_REASON:
          selectedOption = q.options.find(option => option.correct_answer == true);
          answer = selectedOption ? { option_id: selectedOption.id } : null;
          break;

        case this.questionTypes.MULTIPLE_CORRECT:
          options = [];
          q.options.map((o, idx) => {
            if (o.correct_answer == true) {
              options.push(o.id);
            }
          });
          answer = options.length > 0 ? { option_id: options } : null;
          break;

        case this.questionTypes.SINGLE_CORRECT:
        case this.questionTypes.SINGLE_CORRECT_SEC2:
          selectedOption = q.options.find(option => option.correct_answer == true);
          answer = selectedOption ? { option_id: selectedOption.id } : null;
          break;
      }
      return answer;
    },
    getAnswerForComprehension(q) {
      let answer = [];
      if (
        q.subtype == this.questionTypes.COMPREHENSION_2Q_SA ||
        q.subtype == this.questionTypes.COMPREHENSION_2Q_MM ||
        q.subtype == this.questionTypes.COMPREHENSION_3Q_SA ||
        q.subtype == this.questionTypes.TC_2Q_SA ||
        q.subtype == this.questionTypes.TC_3Q_SA
      ) {
        q.questions.map((ques, idx) => {
          let selectedOption = ques.options.find(option => option.correct_answer == true);
          if (selectedOption) {
            answer.push({
              question_id: ques.id,
              option_id: selectedOption.id,
            });
          }
        });
      } else {
        q.questions.map((ques, idx) => {
          let options = [];
          ques.options.map((o, idx) => {
            if (o.correct_answer == true) {
              options.push(o.id);
            }
          });

          if (options.length > 0) {
            answer.push({
              question_id: ques.id,
              option_id: options,
            });
          }
        });
      }
      return answer.length > 0 ? answer : null;
    },
    jumpToQuestion(palletData) {
      let searchedQuestion = JSON.parse(localStorage.getItem("searchedQuestion"));
      if (searchedQuestion) {
        this.updateSearchAnotherQuestion(this.currentQuestion, searchedQuestion);
      }
      localStorage.removeItem("searchedQuestion");
      localStorage.removeItem("currentQuestion");
      sessionStorage.removeItem("selectedQuestionIds");
      this.showNextQuestion = true;
      this.isUploadAndReplace = false;
      this.isSearchAnotherQ = false;
      this.isCallBucketApi = true;

      this.nextQuestionIndex = palletData.currentQuestionIndex;
      this.endAction = this.QUESTION_ACTIONS.JUMP;
      this.scrollQtypeValue = 2;
      this.saveCurrentAction("currentQuestion");
      // this.expansionPanelStatus = null;
    },
    changeSubjectQuestionType(type, index, action) {
      this.endAction = action ? action : this.endAction;
      this.showNextQuestion = true;
      this.isSQTChanged = true;
      this.isUploadAndReplace = false;
      this.isSearchAnotherQ = false;
      this.setCurrentQuestionData(index, type.currentQuestionIndex);
      this.nextQuestionIndex = type.currentQuestionIndex;
      this.saveCurrentAction("currentQuestion");
      if (this.isApiCall) {
        this.getChapters(
          type.questions[0].datatype.parentDetails.id,
          type.questions[0].sub_subject
        );
      }
      this.isApiCall = true;
    },
    reverseQuestionsType() {
      Object.keys(this.questionTypes).forEach(qt => {
        this.questionTypesReversed[this.questionTypes[qt]] = qt;
      });
    },
    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const batchA = parseInt(a.index);
      const batchB = parseInt(b.index);

      let comparison = 0;
      if (batchA > batchB) {
        comparison = 1;
      } else if (batchA < batchB) {
        comparison = -1;
      }
      return comparison;
    },
    async separateQuestions() {
      let Paper = [];
      let paper = {};
      let questions = this.questionsListStore;
      let mandatoryQuestions = this.testDetails.mandatoryQuestionDetails;

      // questions.sort(this.compare);
      let fql = {}; // filteredQuestionsList
      let subjectQuestionTypeList = {}; // for showing subject - section list
      this.$root.showLoader = true;
      for (let i = 0; i < questions.length; i++) {
        let questionTypeId = 0;
        let questionTypeName = "";
        let q = null; // question
        let currentQuestionType = null; // current question in particular subject
        let subjectName = null; // current subject
        let subjectId = null; // current subject
        let subjectQuestionTypeObj = {};
        let questionId = 0;
        let subSubject = null;
        let mandatoryQuestionDetails = {};
        let subTypeName = "",
          subTypeId;
        q = questions[i];
        questionId = q.id;

        //Temporary changes to resole question type issue, need to verify it
        questionTypeId =
          q.questiontype && q.questiontype.id
            ? q.questiontype.id
            : q.question_type
            ? q.question_type
            : "";
        questionTypeName =
          q.questiontype && q.questiontype.value
            ? q.questiontype.value
            : q.question_type_value
            ? q.question_type_value
            : "";
        subTypeName = q.subtype && q.subtype.value ? q.subtype.value : "";
        subTypeId = q.subtype && q.subtype.id ? q.subtype.id : "";
        subjectName = q.subject.title;
        subSubject = q && q.sub_subject ? q.sub_subject : null;
        subjectId = q.subject.id;
        if (q.sub_subject) {
          let subject = constants.BIOLOGY_SUBSUBJECTS.find(s => s.code === q.sub_subject);
          if (subject) {
            subjectName = subject.title;
          }
        }
        let sub = subSubject ? q.subject.id + subSubject : q.subject.id;
        let teacher = this.teacherSubjectId.length
              ?  this.AssignedTeacher.length ? this.AssignedTeacher.findIndex(
                  a =>
                    a.subject_id === subjectId &&
                    a.assigned_to === this.user.id &&
                    (a.sub_subject == null || a.sub_subject == subSubject) &&
                    this.teacherSubjectId.includes(subjectId)
                ) > -1 :this.teacherSubjectId.includes(subjectId)
              :
               true;
        if (
          (this.user.role_id === this.roleIds.TR && teacher) ||
          this.user.role_id !== this.roleIds.TR
        ) {
          let i = Paper.findIndex(
            s => s.id === sub && s.question_type_id === questionTypeId
          );
          if (i > -1) {
            let j = Paper[i].chapters.findIndex(s => s.id === q.datatype.id);
            if (j > -1) {
              Paper[i].chapters[j].questions.push({
                id: q.id,
                index: q.index,
                difficulty: q.difficulty_level,
              });
            } else {
              Paper[i].chapters.push({
                id: q.datatype.id,
                questions: [{ id: q.id, index: q.index, difficulty: q.difficulty_level }],
                name: q.datatype.title,
              });
            }
          } else {
            let ques = {
              id: sub,
              name: subjectName,
              question_type_id: questionTypeId,
              question_type_name: questionTypeName,
              chapters: [
                {
                  id: q.datatype.id,
                  questions: [
                    { id: q.id, index: q.index, difficulty: q.difficulty_level },
                  ],
                  name: q.datatype.title,
                },
              ],
            };
            Paper.push(ques);
          }
        }
        (mandatoryQuestionDetails =
          mandatoryQuestions &&
          mandatoryQuestions.find(
            m => m.subject_id === subjectId && m.question_type === questionTypeId
          )),
          (subjectQuestionTypeObj = {
            subjectName,
            questionTypeName,
            questionTypeId,
            subTypeId,
            subjectId,
            subTypeName,
            subId: sub,
            subSubject,
            mandatoryQuestionDetails,
          });

        let subjectQuestionTypeName = subjectName + questionTypeId + subTypeId || "";
        if (!subjectQuestionTypeList[subjectQuestionTypeName]) {
          subjectQuestionTypeList[subjectQuestionTypeName] = [];
          subjectQuestionTypeList[subjectQuestionTypeName].push(subjectQuestionTypeObj);
        }

        if (!fql[subjectName]) fql[subjectName] = {};
        let questionTypeIDName = subTypeId ? subTypeId : questionTypeId;
        if (!fql[subjectName][questionTypeIDName])
          fql[subjectName][questionTypeIDName] = {};
        currentQuestionType = fql[subjectName][questionTypeIDName];
        if (!currentQuestionType["questionIds"]) currentQuestionType["questionIds"] = []; // list of questions
        currentQuestionType["questionIds"].push(questionId);
      }
      this.setTestData(fql); // in store
      await this.generateQuestionsList();
      this.generateSubjectQuestionList(subjectQuestionTypeList);
      let currentTestCookieExists = this.$cookies.isKey("CATAPULT_TEST");
      let questionIndex = 0;
      let sqtIndex = 0;
      if (currentTestCookieExists) {
        let currentTestDetails = this.$cookies.get("CATAPULT_TEST");
        if (
          currentTestDetails.testId == this.$route.params.test_id &&
          currentTestDetails.testInstituteId == this.$route.params.test_institute_id &&
          currentTestDetails.userId == this.user.id
        ) {
          this.nextQuestionIndex = currentTestDetails.currentQuestionIndex;
          sqtIndex = currentTestDetails.currentSQTIndex;
        }
        let navigateTo = sqtIndex;
        if (isMobile()) {
          this.navigateTo = navigateTo;
        } else if (
          sqtIndex > 2 &&
          sqtIndex > this.subjectQuestionTypeList.length - 3 &&
          this.subjectQuestionTypeList.length > 2
        ) {
          navigateTo = sqtIndex - 2;
          this.navigateTo = navigateTo;
        }
      }
      this.paperCoverage = Paper;
      this.setCurrentQuestionData(sqtIndex, 0);
    },
    setCurrentQuestionData(typeIndex, questionIndex) {
      this.setSelectedSQTIndex(typeIndex);
    },
    async generateQuestionsList() {
      let ql = this.questionsListStore;
      let currentQuestion = {};
      let questionsList = [];
      for (let i = 0; i < ql.length; i++) {
        const q = ql[i]; // current question in loop
        let questionTypeId = q.question_type;
        questionTypeId =
          questionTypeId == this.questionTypes.COMPREHENSION ||
          questionTypeId == this.questionTypes.TC
            ? q.subtype.id
              ? q.subtype.id
              : q.subtype
            : q.question_type;
        let currentQuestion = {};
        currentQuestion = this.generateQuestionObject(questionTypeId, q);
        currentQuestion.subtype = q.subtype
          ? q.subtype.id
            ? q.subtype.id
            : q.subtype
          : "";
        if (
          q.question_type == this.questionTypes.COMPREHENSION ||
          q.question_type == this.questionTypes.TC
        ) {
          currentQuestion.passage = q.passage;
        }
        currentQuestion = this.getCurrentQuestionCommonKeys(currentQuestion, q);
        if (this.isPreview) {
          if (q.questionBucket.length) {
            for (let j = 0; j < q.questionBucket.length; j++) {
              const bq = q.questionBucket[j].question; // current question in loop
              let questionTypeId = bq.question_type;
              questionTypeId =
                questionTypeId == this.questionTypes.COMPREHENSION ||
                questionTypeId == this.questionTypes.TC
                  ? bq.subtype.id
                    ? bq.subtype.id
                    : bq.subtype
                  : bq.question_type;
              let bucketQuestion = {};
              bucketQuestion = this.generateQuestionObject(questionTypeId, bq);
              bucketQuestion.subtype = bq.subtype
                ? bq.subtype.id
                  ? bq.subtype.id
                  : bq.subtype
                : "";
              if (
                bq.question_type == this.questionTypes.COMPREHENSION ||
                bq.question_type == this.questionTypes.TC
              ) {
                bucketQuestion.passage = bq.passage;
              }
              bucketQuestion = this.getCurrentQuestionCommonKeys(
                bucketQuestion,
                bq,
                j,
                q.index
              );
              currentQuestion.questionBucket.push(bucketQuestion);
            }
          }
        }
        questionsList.push(currentQuestion);
      }
      this.setFilteredQuestionsList(questionsList);
    },
    getCurrentQuestionCommonKeys(currentQuestion, q, index, bq) {
      currentQuestion.id = q.id;
      currentQuestion.questionNo = q.index ? q.index : bq;
      currentQuestion.suggestions = index + 1;
      currentQuestion.question_text = q.question_text.replace(/equation-class/gi,'equation');
      currentQuestion.question_type = q.question_type;
      currentQuestion.questionType = { id: q.question_type };
      currentQuestion.parent_id = q.parent_id;
      currentQuestion.section_id = q.section_id;
      currentQuestion.test_detail_id = q.test_detail_id;
      currentQuestion.correct_marks = q.marks;
      currentQuestion.negative_marks = q.negative_marks;
      currentQuestion.partial_marking = q.partial_marking;
      currentQuestion.solution = q.solution;
      currentQuestion.solution = q.solution.replace(/equation-class/gi,'equation');
      currentQuestion.hints = q.hints;
      currentQuestion.userSelectedAnswer = q.user_selected_answer;
      currentQuestion.status = this.questionStatus.INITIAL; // "status" along with "isAnswered" will be used for loading legends & pallet info
      currentQuestion.isAnswered = false; // to know if the current question is answered.
      currentQuestion.disabled = false; // disabled in case of preview test
      currentQuestion.isPreview = this.isPreview; // disabled in case of preview
      currentQuestion.isAttemptingTest = !this.isPreview;
      currentQuestion.institute_id = q.question_institute_id;
      currentQuestion.sub_subject = q.sub_subject;
      currentQuestion.tags = q.tags;
      currentQuestion.showTags = false;
      currentQuestion.questionBucket = [];
      if (this.isPreview) {
        currentQuestion.status = this.questionStatus.ANSWER_SELECTED_SAVED; // "status" along with "isAnswered" will be used for loading legends & pallet info
        currentQuestion.isAnswered = this.isPreview; // to know if the current question is answered.
        currentQuestion.disabled = this.isPreview; // disabled in case of preview test
      }
      if (q.user_selected_answer && !this.isPreview) {
        let answer = JSON.parse(q.user_selected_answer);
        currentQuestion.isAnswered = answer.answer ? true : false;
        currentQuestion.status = answer.status;
      }
      if (this.user.role_id === this.roleIds.TR) {
        const index = this.teacherSubjectId.findIndex(t =>
          q.subject ? t === q.subject.id : t === q.datatype.parentDetails.id
        );
        currentQuestion.isQuestionEditable = index >= 0;
      } else {
        currentQuestion.isQuestionEditable = true;
      }
      return currentQuestion;
    },
    checkIfAnswered(type, q) {
      let option = null;
      if (q.user_selected_answer && !this.isPreview) {
        let answer = JSON.parse(q.user_selected_answer);
        q.status = answer.status;
        let options = q.options.map(o => {
          return { ...o, ...{ correct_answer: false } };
        });
        if (answer.answer) {
          let switchType = 1;
          if (
            this.questionTypes.ASSERTION_REASON == type ||
            this.questionTypes.SINGLE_CORRECT == type ||
            this.questionTypes.SINGLE_CORRECT_SEC2 == type ||
            this.questionTypes.COMPREHENSION_2Q_SA == type ||
            this.questionTypes.COMPREHENSION_2Q_MM == type ||
            this.questionTypes.COMPREHENSION_3Q_SA == type ||
            this.questionTypes.TC_2Q_SA == type ||
            this.questionTypes.TC_3Q_SA == type
          ) {
            switchType = 1;
          } else {
            switchType = 2;
          }
          switch (switchType) {
            case 1:
              option = options.find(o => o.id == answer.answer.option_id);
              if (option) option.correct_answer = true;
              break;

            case 2:
              answer.answer.option_id.map(a => {
                option = options.find(o => o.id == a);
                if (option) option.correct_answer = true;
              });
              break;
          }
        }
        return options;
      } else return q.options;
    },
    generateQuestionObject(typeId, q) {
      let type = "";
      type = this.getQuestionType(typeId);
      let currentQuestion = {};
      currentQuestion.chapterId = q.data_type_id;
      currentQuestion.chapterName = q.datatype ? q.datatype.title : "";
      currentQuestion.dataType = q.datatype;
      currentQuestion.datatype = q.datatype;
      currentQuestion.answer_type = q.answer_type;
      currentQuestion.difficulty = q.difficulty;
      if (q.difficulty_level) {
        currentQuestion.difficulty_level = q.difficulty_level || null;
        currentQuestion.difficultyName = this.difficulty.find(
          d => d.id === q.difficulty_level
        ).title;
        currentQuestion.difficultyId = this.difficulty.find(
          d => d.id === q.difficulty_level
        ).id;
      }
      currentQuestion.question_bucket_count = q.question_bucket_count;
      currentQuestion.time = q.time;
      currentQuestion.topic_id = q.topic_id;
      currentQuestion.topicName = q.topic ? q.topic.title : "";
      currentQuestion.subtopic_id = q.subtopic_id;
      currentQuestion.subtopicName = q.subtopic ? q.subtopic.title : "";
      currentQuestion.subtopic = q.subtopic;
      currentQuestion.concept_id = q.concept_id;
      currentQuestion.conceptName = q.concept ? q.concept.title : "";
      currentQuestion.concept = q.concept;
      currentQuestion.answer_type = q.answer_type;
      currentQuestion.skillsetName = q.answertype ? q.answertype.value : "";
      currentQuestion.answertype = q.answertype;
      currentQuestion.subType = q.subtype;
      currentQuestion.topic = q.topic;
      currentQuestion.sub_subject = q.sub_subject;
      currentQuestion = this.getCurrentQuestionCommonKeys(currentQuestion, q);
      switch (type) {
        case 1:
          currentQuestion.options = this.checkIfAnswered(typeId, q);
          currentQuestion.options = currentQuestion.options.map(o=>{
            o.option_text=o.option_text.replace(/equation-class/g,'equation')
            return o;
          });
          break;
        case 2:
          if (this.isPreview) {
            currentQuestion.correct_answer = q.correct_answer;
          } else if (q.user_selected_answer) {
            let answer = JSON.parse(q.user_selected_answer);
            currentQuestion.correct_answer = parseInt(answer.answer);
          } else {
            currentQuestion.correct_answer = null;
          }
          break;
        case 3:
          let matrixOptions = this.separateOptions(q, 1);
          currentQuestion.options_abc = matrixOptions.options_abc.map(o=>{
            o.option_text=o.option_text.replace(/equation-class/g,'equation')
            return o;
          });;
          currentQuestion.options_pqr = matrixOptions.options_pqr.map(o=>{
            o.option_text=o.option_text.replace(/equation-class/g,'equation')
            return o;
          });;
          break;
        case 4:
          let options = this.separateOptions(q, 2);
          currentQuestion.options_abc = options.options_abc.map(o=>{
            o.option_text=o.option_text.replace(/equation-class/g,'equation')
            return o;
          });
          currentQuestion.options_pqr = options.options_pqr.map(o=>{
            o.option_text=o.option_text.replace(/equation-class/g,'equation')
            return o;
          });;
          currentQuestion.options = options.op.map(o=>{
            o.option_text=o.option_text.replace(/equation-class/g,'equation')
            return o;
          });;
          break;
        case 6:
          if (this.isPreview) {
            currentQuestion.correct_answer = q.correct_answer;
          } else if (q.user_selected_answer) {
            let answer = JSON.parse(q.user_selected_answer);
            currentQuestion.correct_answer = answer.answer;
          } else {
            currentQuestion.correct_answer = "";
          }
          let subjectiveAnswers = this.getSubjectiveAnswers(
            currentQuestion.correct_answer,
            q
          );
          currentQuestion.startValue = subjectiveAnswers.startValue;
          currentQuestion.endValue = subjectiveAnswers.endValue;
          break;
      }
      return currentQuestion;
    },
    getQuestionType(id) {
      if (
        id == this.questionTypes.ASSERTION_REASON ||
        id == this.questionTypes.MULTIPLE_CORRECT ||
        id == this.questionTypes.SINGLE_CORRECT ||
        id == this.questionTypes.SINGLE_CORRECT_SEC2 ||
        id == this.questionTypes.COMPREHENSION_2Q_SA ||
        id == this.questionTypes.COMPREHENSION_2Q_MA ||
        id == this.questionTypes.COMPREHENSION_3Q_SA ||
        id == this.questionTypes.COMPREHENSION_3Q_MA ||
        id == this.questionTypes.TC_2Q_SA ||
        id == this.questionTypes.COMPREHENSION_2Q_MM ||
        id == this.questionTypes.TC_3Q_SA
      ) {
        return 1;
      } else if (id == this.questionTypes.INTEGER) {
        return 2;
      } else if (id == this.questionTypes.MATRIX_MATCH) {
        return 3;
      } else if (id == this.questionTypes.MATRIX_MATCH_OPTION) {
        return 4;
      } else if (id == this.questionTypes.COMPREHENSION) {
        return 5;
      } else if (
        id == this.questionTypes.SUBJECTIVE ||
        id == this.questionTypes.COMPREHENSION_2Q_NU ||
        id == this.questionTypes.SUBJECTIVEINTEGER
      ) {
        return 6;
      }
    },
    getSubjectiveAnswers(answer, q) {
      let separatedAnswer = {
        startValue: null,
        endValue: null,
      };
      if (answer > "" && this.isPreview) {
        let answerArray = answer.split("##");
        if (answerArray.length == 2) {
          separatedAnswer.startValue = answerArray[0];
          separatedAnswer.endValue = answerArray[1];
        } else if (answerArray.length == 1) {
          separatedAnswer.startValue = answerArray[0];
        }
      } else if (q.user_selected_answer) {
        let answer = JSON.parse(q.user_selected_answer);
        if (answer.answer && !answer.answer.startValue && !answer.answer.endValue) {
          separatedAnswer.correct_answer = parseInt(answer.answer);
        }
      }
      return separatedAnswer;
    },
    generateSubjectQuestionList(subjectQuestionTypeList) {
      let sqtl = []; // subjectQuestionTypeList
      let subjectQuestionTypeObj = {};
      let name = "";
      let shortName = "";
      let typeId = "";
      let subTypeId = "";
      let subjectId = "";
      let subjectName = "";
      let subSubject = null;
      let questionIds = [];
      let typeList = [];
      let questions = [];
      let questionObj = {};
      let mandatoryQuestions = {};
      let subjectNames = Object.keys(subjectQuestionTypeList);
      subjectNames.forEach(subject => {
        typeList = subjectQuestionTypeList[subject];
        questions = [];
        typeList.forEach(type => {
          questionObj = {};
          name =
            type.subjectName +
            " - " +
            (type.subTypeName ? type.subTypeName : type.questionTypeName);
          shortName = type.subjectName
            ? type.subjectName.substr(0, 4) +
              " - " +
              (type.subTypeName ? type.subTypeName : type.questionTypeName)
            : null;
          typeId = type.questionTypeId;
          subTypeId = type.subTypeId;
          subjectId = type.subjectId;
          subjectName = type.subjectName;
          subSubject = type.subSubject ? type.subSubject : null;
          mandatoryQuestions = type.mandatoryQuestionDetails;
          let typeIdName = subTypeId ? subTypeId : typeId;
          questionIds = this.testData[type.subjectName][typeIdName].questionIds;
          // questionIds.sort();
          questionIds.forEach((qi, idx) => {
            questionObj = {};
            questionObj = this.filteredQuestionsList.find(q => q.id === qi);
            questionObj.currentQuestionIndex = idx + 1;
            questions.push(questionObj);
          });
          subjectQuestionTypeObj = {
            name,
            shortName,
            typeId,
            subjectId: type.subId,
            questionIds,
            subjectName,
            questions,
            showSQT: this.teacherSubjectId.length
              ?  this.AssignedTeacher.length ? this.AssignedTeacher.findIndex(
                  a =>
                    a.subject_id === subjectId &&
                    a.assigned_to === this.user.id &&
                    (a.sub_subject == null || a.sub_subject == subSubject) &&
                    this.teacherSubjectId.includes(subjectId)
                ) > -1 :this.teacherSubjectId.includes(subjectId)
              :
               true,
            currentQuestionIndex: 0,
            mandatoryQuestions,
            showAnswerField: true, // will be changed to true when loading into question paper modal
          };
          if (subjectQuestionTypeObj.showSQT) {
            sqtl.push(subjectQuestionTypeObj);
          }
        });
      });
      if (sqtl && sqtl.length > 0) {
        // this.getChapters(sqtl[0].subjectId);
      }
      this.setSubjectQuestionTypeList(sqtl);
      this.$root.showLoader = false;
      // this.subjectQuestionTypeList = sqtl;
    },
    onClose(data) {
      this.status = data.status;
      if (data.callApi) {
        this.requestGetTestDetails();
      }
      if (data.count) {
        this.currentQuestion.question_bucket_count = data.count;
      } else if (data.count === 0) {
        this.currentQuestion.question_bucket_count = 0;
      }
      if (!data.fromAlertBox && data && data.instructions) {
        //this.instructions = data.instructions;
        this.updateInstructions(data.instructions);
      }
      this.isCallBucketApi = false;
      //   if(data.reload){
      // 	  this.requestGetTestDetails();
      //   }
    },
    logOutUser() {
      console.log("Preview Test logout Function");
      this.$toasted.error(
        "You have a slow internet connection. Please check and try again."
      );
      this.logOut().then(() => {
        console.log("Preview Test logout Api Call");
        this.$router.push({ name: "login" }).catch(() => {});
        this.$cookies.remove("userToken", this.COOKIE_PATH, this.COOKIE_DOMAIN);
        this.$cookies.remove("isShowErrorMsg", this.COOKIE_PATH, this.COOKIE_DOMAIN);
        this.$cookies.remove("keepMeLoggedIn", this.COOKIE_PATH, this.COOKIE_DOMAIN);
        this.$cookies.remove("upgrade", this.COOKIE_PATH, this.COOKIE_DOMAIN);
        this.$cookies.remove("isLoggedIn", this.COOKIE_PATH, this.COOKIE_DOMAIN);
      });
    },
    waitForResponse() {
      console.log("Preview Test waitForResponse Function");
      let remainingSeconds = 60;
      this.$root.showLoader = true;
      this.responseTimeOut = setInterval(() => {
        this.$root.showLoader = true;
        if (remainingSeconds <= 0 && !this.testDetails) {
          console.log("Preview Test remainingSeconds if condition");
          console.log({ RemainingTime: remainingSeconds });
          clearInterval(this.responseTimeOut);
          this.$root.showLoader = false;
          this.setIsTestStarted(false);
          this.logOutUser();
        }
        if (this.testDetails && this.testDetails.questions) {
          clearInterval(this.responseTimeOut);
          this.$root.showLoader = false;
        }
        remainingSeconds--;
      }, 1000);
    },
    requestGetTestDetails() {
      let pendingTestList = this.pendingTestList;
      if (
        parseInt(this.$route.params.test_id) &&
        parseInt(this.$route.params.test_institute_id)
      ) {
        let reqData = {
          test_id: this.$route.params.test_id,
          test_institute_id: this.$route.params.test_institute_id,
          is_preview: this.isPreview,
        };
        if (!this.isPreview) {
          reqData.test_schedule_id = this.$route.params.test_schedule_id;
        }
        this.$root.showLoader = true;
        let fn = "getTestPreviewDetails";
        if (!this.isPreview) {
          fn = "getLiveTestDetails";
        }
        this[fn](reqData)
          .then(response => {
            if (response) {
              this.$root.showLoader = false;
              this.testDetails = response;
              this.isAits = response?.questions[0]?.is_shared_test && this.currentInstituteId !== constants.AITS_INSTITUTE_ID[0] ? true : false
              this.duration = this.testDetails.timeRemaining;
              this.isOnlineTest =
                localStorage.getItem("isOnlineTest", this.tab) === "Online";

              if (!this.isPreview) {
                this.startTimer(this.testDetails.timeRemaining);
                this.startHeartBeatTimer();
                this.getRemainingTimeInterval();
                this.getTabCount();
              }
              if (
                this.testDetails.test_type != this.TEST_TYPE.CUSTOM &&
                (this.$route.name == "preview-test" ||
                  this.$route.name == "result-anaylysis-preview-test")
              ) {
                this.isTestCustom = false;
              }
              this.isDBTest = this.testDetails.is_db_test === 1;
              this.isEditable = this.testDetails.test_is_conducted_or_running === 1;
              this.instructions = response.instructions;
              this.separateQuestions();
              this.renderMath();
              sendRelicInterval = setInterval(() => {
                this.sendRelicError();
                if (navigator.onLine) {
                  this.sendStoredLogData();
                }
              }, 1000);
              // this.getQuestionData();
            } else {
              let error_log = new Error(`**START_LIVE_API** LIVE_STUD::${
                this.user.id
              } : ${reqData.test_schedule_id},api:'start-live', 
              payload:${JSON.stringify(reqData)}, 
              response:${JSON.stringify(response)},
              networkStatus: ${navigator.onLine}, 
              user_id: ${this.user.id}`);
              localStorage.setItem("error_live_test", error_log);
              this.sendLogData(response, "heart-beat", "live-test-api", reqData);

              this.$toasted.error(
                `Sorry!!!, We are unable to fetch test information. Please check\n1.  You are connected to internet\n2.  Your browser is up to date\n3.  Please check your firewall settings.\nStill error persist please contact admin with screenshot.`,
                { icon: "info", className: "custom-toast" }
              );
            }
          })
          .catch(err => {
            this.$root.showLoader = false;
            if (!this.isPreview) {
              let errObj = "";
              if (err && err.data && err.data.errors) {
                errObj = err.data.errors;
              } else if (err && err.data) {
                errObj = err.data;
              } else {
                errObj = err;
              }
              let error_log = new Error(`
              **START_LIVE_API** LIVE_STUD::${this.user.id} : ${
                reqData.test_schedule_id
              },api:'start-live', 
              payload:${JSON.stringify(reqData)}, 
              error:${JSON.stringify(errObj)},
              networkStatus: ${navigator.onLine}, 
              user_id: ${this.user.id}`);
              localStorage.setItem("error_live_test", error_log);
              this.sendLogData(errObj, "start-live", "live-test-api", reqData);
            }
            if (pendingTestList) {
              pendingTestList.shift();
              this.setPendingTestList(pendingTestList);
            }
            this.setIsTestStarted(false);
            this.$toasted.error(
              `Sorry!!!, We are unable to fetch test information. Please check\n1.  You are connected to internet\n2.  Your browser is up to date\n3.  Please check your firewall settings.\nStill error persist please contact admin with screenshot.`,
              { icon: "info", className: "custom-toast" }
            );
            // this.redirectAsType();
            this.$router.push({ name: this.user.role_id === this.roleIds.ST?"live-test":"schedule-tests" });
          });
      }
    },
    separateOptions(q, type) {
      let options = q.options;
      let op = [];
      let options_abc = [];
      let options_pqr = [];

      options.forEach(option => {
        if (option.column == 1) {
          option.correct_answer = option.correct_answer ? option.correct_answer : "";
          options_abc.push(option);
        } else if (option.column == 2) options_pqr.push(option);
        else {
          option.correct_answer = option.correct_answer ? option.correct_answer : false;
          // option.correct_answer = false;
          op.push(option);
        }
      });
      if (type == 1) {
        if (q.user_selected_answer) {
          let answer = JSON.parse(q.user_selected_answer);
          if (answer.answer) {
            answer.answer.map(a => {
              let option = options_abc.find(o => o.id == a.option_id);
              if (option) {
                option.correct_answer = a.value;
              }
            });
          }
        }
      } else {
        if (q.user_selected_answer) {
          let answer = JSON.parse(q.user_selected_answer);
          if (answer.answer) {
            let option = op.find(o => o.id == answer.answer.option_id);
            if (option) {
              option.correct_answer = true;
            }
          }
        }
      }

      return {
        op,
        options_abc,
        options_pqr,
      };
    },
    disableNavigation() {
      document.addEventListener("visibilitychange", this.checkVisiblity);
      // window.onfocus = this.checkPageStatus;
      // window.onblur = this.checkPageStatus;
      history.pushState(null, null, location.href);
      history.back();
      history.forward();
      window.onpopstate = function () {
        history.go(1);
      };
      document.addEventListener(
        "click",
        function enableNoSleep() {
          document.removeEventListener("click", enableNoSleep, false);
          noSleep.enable();
        },
        false
      );
      // setInterval(()=>{
      //   this.vueInsomnia().on();
      //   noSleep.enable();
      // },14000)
      window.onfocus = this.pageFocused;
      window.onblur = this.pageBlurred;
    },
    checkVisiblity() {
      console.log("In check invisibilty", document.visibilityState);
      if (document.visibilityState !== "visible") {
        this.pageBlurred();
      } else {
        this.pageFocused();
      }
      // if (document.visibilityState === "visible") {
      //   if (this.isBlurred) {
      //     this.isBlurred = false;
      //     this.getRemainingTime(false);
      //   }
      //   // this.isBlurred = false;
      //   // this.getRemainingTime();
      // } else {
      //   if (this.timeRemainingInterval) {
      //     clearInterval(this.timeRemainingInterval);
      //     this.timeRemainingInterval = null;
      //   }
      //   this.isBlurred = true;
      //   this.hideTimer = true;
      // }
    },

    pageBlurred() {
      if (this.$device.isMobile) {
        let tabStartTime = sessionStorage.getItem("tabSwitchTime");
        if (!tabStartTime) {
          sessionStorage.setItem("tabSwitchTime", new Date().getTime());
        }
      }
      if (this.pageBlurredTrigger) clearTimeout(this.pageBlurredTrigger);
      this.pageBlurredTrigger = setTimeout(() => {
        this.pageBlurredFunc();
      }, 3000);
    },

    pageBlurredFunc() {
      this.isBlurred = true;
      if (this.timeRemainingInterval) {
        clearInterval(this.timeRemainingInterval);
        this.timeRemainingInterval = null;
      }
      // if (this.testDetails) {
      //   this.getRemainingTime();
      // }

      this.hideTimer = true;
      if (!this.isTabChanged && !this.$device.isMobile && this.testDetails.is_tab_change_required ==1) {
        this.isTabChanged = true;
        this.tabChanged();
      }
    },

    pageFocused() {
      if (this.$device.isMobile) {
        const MAX_TAB_DIFF_TIME = 3000;
        let tabStartTime = sessionStorage.getItem("tabSwitchTime");
        let tabEndTime = new Date().getTime();
        let diffTabTime = tabEndTime - parseInt(tabStartTime);
        if (diffTabTime >= MAX_TAB_DIFF_TIME) {
          if (!this.isTabChanged && this.testDetails.is_tab_change_required == 1) {
            this.isTabChanged = true;
            this.tabChanged();
          } else {
            sessionStorage.removeItem("tabSwitchTime");
          }
        } else {
          sessionStorage.removeItem("tabSwitchTime");
        }
      } else {
        sessionStorage.removeItem("tabSwitchTime");
      }
      if (this.pageBlurredTrigger) clearTimeout(this.pageBlurredTrigger);

      this.pageBlurredTrigger = setTimeout(() => {
        this.pageFocusedFunc();
      }, 3000);
    },

    pageFocusedFunc() {
      if (!this.pageBlurredTrigger) {
        return;
      }
      if (this.$route.name === "test") {
        if (this.isBlurred) {
          this.isBlurred = false;
          this.pageBlurredTrigger = false;
          this.getRemainingTime(false);
        }
      }
    },

    checkPageStatus() {
      /**
       * - below code is for getting remaining time when tabs are switched for more than 3 minutes
       * - remaining part handled in heartbeat method
       * */
      // this.pageInactive = true;
      // this.inactiveStartTime = moment();
    },
    getRemainingTime(isInterval) {
      let postData = {
        test_institute_id:
          this.testDetails && this.testDetails.test_institute_id
            ? this.testDetails.test_institute_id
            : this.$route.params && this.$route.params.test_institute_id
            ? this.$route.params.test_institute_id
            : 0,
        test_detail_id: this.currentQuestion.test_detail_id,
        test_schedule_id: this.testDetails ? this.testDetails.test_schedule_id : -1,
      };
      if (parseInt(postData.test_institute_id) == 0) {
        let errObj = {
          errMsg: "test_institue_id not found",
        };
        this.sendLogData(errObj, "get-remaining-time", "live-test-api", postData);
      }
      // if (this.timeRemainingInterval) {
      //     clearInterval(this.timeRemainingInterval);
      // }
      this.remainingTime(postData)
        .then(res => {
          // this.pageInactive = false;
          if (!isInterval) this.isBlurred = false;
          this.startTimer(res.remaining_time);
          // this.hideTimer = false;
        })
        .catch(err => {
          let errObj = "";
          if (err && err.data && err.data.errors) {
            errObj = err.data.errors;
          } else if (err && err.data) {
            errObj = err.data;
          } else {
            errObj = err;
          }
          let error_log = new Error(`
          ***GET-REMAINING-TIME** LIVE_ST::${this.user.id}:${
            this.testDetails.test_schedule_id
          },
          api:'get-remaining-time', 
          payload:${JSON.stringify(postData)}, 
          error:${JSON.stringify(errObj)},
          networkStatus: ${navigator.onLine}, 
          user_id: ${this.user.id}`);
          localStorage.setItem("error_live_test", error_log);
          this.sendLogData(errObj, "get-remaining-time", "live-test-api", postData);

          if (err.data && err.data.errors) {
            err.data.errors.forEach(e => {
              if (
                e.code == this.ERROR_CODES.TIMEOUTERROR ||
                e.code == this.ERROR_CODES.TESTNOTACTIVE
              ) {
                this.autoSubmitError = e.code;
                this.autoSubmitEndAction = "get-remaining-time";
                let LogData = new Error(`
                user_id: ${this.user.id.toString()},
                test_id: ${
                  this.testDetails && this.testDetails.id
                    ? this.testDetails.id.toString()
                    : "Not Found"
                },
                event_name: ${e.code}, 
                time: ${moment().format("YYYY-MM-DD HH:mm:ss.SSS").toString()}`);

                this.autoSubmitTestData();
                this.setIsTestStarted(false);
                sessionStorage.removeItem("changedTab");
                this.redirectAsType();
              }
            });
          } else {
            if (this.isOnline) {
              // this.$toasted.error("Error getting details.");
              location.reload();
            }
          }
        });
    },
    redirectAsType() {
      let route =this.user.role_id === this.roleIds.ST?"live-test":"schedule-tests";
      let previousRoute = localStorage.getItem("previousRoute");
      if (previousRoute === "make-your-test") {
        route = previousRoute;
      }
      switch (this.testDetails.test_type) {
        case this.TEST_TYPE.PREVIOUS_YEAR:
          route = "premium-test";
          break;
        case this.TEST_TYPE.CUSTOM:
          route =this.user.role_id === this.roleIds.ST?"live-test":"schedule-tests";
          break;
      }
      this.removeCookie();
      noSleep.disable();
      this.$router.push({ name: route });
    },
    handleKeyboardEvents() {
      document.addEventListener("contextmenu", function (e) {
        e.preventDefault();
      });
      document.onkeydown = function (e) {
        if (event.keyCode == 123) {
          return false;
        }
        if (e.ctrlKey && e.keyCode == "R".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.shiftKey && e.keyCode == "R".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.shiftKey && e.keyCode == "I".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.shiftKey && e.keyCode == "C".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.shiftKey && e.keyCode == "J".charCodeAt(0)) {
          return false;
        }
        if (e.ctrlKey && e.keyCode == "U".charCodeAt(0)) {
          return false;
        }
      };
      // switch (event.keyCode) {
      //     case 116: // 'F5'
      //         event.preventDefault();
      //         event.returnValue = false;
      //         break;
      //     case 82: // 'F5'
      //         event.preventDefault();
      //         event.returnValue = false;
      //         event.keyCode = 0;
      //         window.status = "We have disabled F5";
      //         break;
      // }
    },
    replaceToOriginal() {
      if (this.isSearchAnotherQ) {
        const question = JSON.parse(localStorage.getItem("searchedQuestion"));
        // this.currentQuestion = question
        this.updateSearchAnotherQuestion(this.currentQuestion, question);
        this.currentQuestion.last_created_at = question.last_created_at;
        this.isSearchAnotherQ = false;
        localStorage.removeItem("searchedQuestion");
        localStorage.removeItem("currentQuestion");
      }
      if (this.isUploadAndReplace) {
        const question = JSON.parse(localStorage.getItem("currentQuestion"));
        // this.currentQuestion = question

        this.updateSearchAnotherQuestion(this.currentQuestion, question);
        this.currentQuestion.last_created_at = question.last_created_at;
        this.isUploadAndReplace = false;
        localStorage.removeItem("searchedQuestion");
        localStorage.removeItem("currentQuestion");
      }
      sessionStorage.removeItem("selectedQuestionIds");
      this.isEditing = false;
    },
    searchAnotherQ() {
      if (!this.isSearchAnotherQ) {
        this.slectedChapter = {
          chapter_id: this.currentQuestion.chapterId,
          title: this.currentQuestion.chapterName,
        };

        this.getTopics(this.slectedChapter.chapter_id);
      }
      this.isUploadAndReplace = false;
      if (!this.isSearchAnotherQ) {
        this.selectedTopic = {
          topic_id: this.currentQuestion.topic_id,
          title: this.currentQuestion.topicName,
        };
      }
      if (!this.isSearchAnotherQ) {
        this.selectedDifficultyLevel = {
          id: this.currentQuestion.difficultyId,
          title: this.currentQuestion.difficultyName,
        };
      }

      this.$forceUpdate();
      this.$root.showLoader = true;

      this.isSearchAnotherQ = true;
      let isSet = JSON.parse(localStorage.getItem("searchedQuestion"));
      if (!isSet) {
        localStorage.setItem("searchedQuestion", JSON.stringify(this.currentQuestion));
      }

      const test = JSON.parse(localStorage.getItem("test"));
      let selectedQuestionIds = [];
      selectedQuestionIds = JSON.parse(sessionStorage.getItem("selectedQuestionIds"));
      if (!selectedQuestionIds) {
        selectedQuestionIds = [];
        selectedQuestionIds.push(this.currentQuestion.id);
        sessionStorage.setItem(
          "selectedQuestionIds",
          JSON.stringify(selectedQuestionIds)
        );
      }
      const reqData = {
        test_detail_id: this.currentQuestion.test_detail_id,
        subject_id: this.currentQuestion.dataType.parent,
        required_questions: 1,
        question_type: this.currentQuestion.question_type,
        target_exam: test.target,
        difficulty_level: this.selectedDifficultyLevel
          ? this.selectedDifficultyLevel.id
          : 1,

        chapter_ids: this.slectedChapter.chapter_id
          ? [this.slectedChapter.chapter_id]
          : [],
        topic_ids: this.selectedTopic.topic_id ? [this.selectedTopic.topic_id] : [],

        test_id: test.id,
        required_question_details: true,
        selectedQuestionIds: selectedQuestionIds,
        required_single_child_question_details:
          this.currentQuestion.question_type === this.questionTypes.COMPREHENSION ||
          this.currentQuestion.question_type === this.questionTypes.TC,
        target_exam: this.testDetails.target,
      };
      if (this.slectedChapter.chapter_id) {
        reqData.chapter_ids = [this.slectedChapter.chapter_id];
      }
      if (this.selectedTopic.topic_id) {
        reqData.topic_ids = [this.selectedTopic.topic_id];
      }

      if (this.selectedDifficultyLevel.id) {
        reqData.difficulty_level = this.selectedDifficultyLevel.id;
      }

      if (this.currentQuestion.subtype) {
        reqData.subType = this.currentQuestion.subtype;
      }
      this.searchAnotherQuestion(reqData)
        .then(response => {
          this.$root.showLoader = false;

          if (response.list && response.list.length) {
            if (
              this.currentQuestion.question_type === this.questionTypes.COMPREHENSION ||
              this.currentQuestion.question_type === this.questionTypes.TC
            ) {
              selectedQuestionIds.push(response.list[0].parent_id);
              // this.requestGetTestDetails();
            } else {
              selectedQuestionIds.push(response.list[0].id);
            }
            sessionStorage.setItem(
              "selectedQuestionIds",
              JSON.stringify(selectedQuestionIds)
            );
            this.setDisableSecondaryAction(false);
            this.updateSearchAnotherQuestion(this.currentQuestion, response.list[0]);
            if (this.selectedDifficultyLevel.id === response.list[0].difficulty_level) {
              this.$toasted.success(`${response.message}`, {
                icon: "check_circle",
              });
            } else {
              this.$toasted.success(
                `Couldn't find the exact match of the difficulty level, hence, suggesting the most suitbale question available`,
                {
                  icon: "check_circle",
                }
              );
              this.selectedDifficultyLevel = {
                id: response.list[0].difficulty_level,
                title:
                  this.difficulty.find(d => d.id === response.list[0].difficulty_level)
                    .title || "",
              };
            }
          } else {
            this.$toasted.error("Question not found with selected priorities");
            // this.isSearchAnotherQ = false;
          }
        })
        .catch(err => {
          this.$root.showLoader = false;
        });
    },
    replaceSearchAnotherQuestion() {
      const reqData = {
        test_detail_id: this.currentQuestion.test_detail_id,
        test_id: this.testDetails.id,
        question_id: this.currentQuestion.id,
        question_type: this.currentQuestion.question_type,
      };
      if (
        this.currentQuestion.question_type === this.questionTypes.COMPREHENSION ||
        this.currentQuestion.question_type === this.questionTypes.TC
      ) {
        reqData.question_id = this.currentQuestion.parent_id;
        // this.requestGetTestDetails();
      }
      this.replaceTestQuestion(reqData)
        .then(response => {
          // if (
          //     this.currentQuestion.question_type === this.questionTypes.COMPREHENSION ||
          //     this.currentQuestion.question_type === this.questionTypes.TC
          //   ) {
          this.requestGetTestDetails();
          // }
          // else{

          //   this.updateSearchAnotherQuestion(
          //     this.currentQuestion,
          //     response.details
          //   );
          // }
          this.setDisableSecondaryAction(false);
          this.$toasted.success(`${response.message}`, {
            icon: "check_circle",
          });
          localStorage.removeItem("searchedQuestion");
          localStorage.removeItem("currentQuestion");
          sessionStorage.removeItem("selectedQuestionIds");
          this.isSearchAnotherQ = false;
        })
        .catch(err => {
          this.$toasted.error("Error Replacing Question");
          // this.isSearchAnotherQ = false
        });
    },
    getAnswerType(questionType, subtype) {
      let answerType = 0;

      if (
        questionType == this.QUE_TYPES.COMPREHENSION ||
        questionType == this.QUE_TYPES.TC
      ) {
        answerType = 0; // for questions with subtypes
        if (
          subtype == this.QUE_TYPES.TC_2Q_SA ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_SA ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_MA ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_MM ||
          subtype == this.QUE_TYPES.COMPREHENSION_2Q_NU
        ) {
          this.subQuestionLength = 2;
        } else if (
          subtype == this.QUE_TYPES.COMPREHENSION_3Q_MA ||
          subtype == this.QUE_TYPES.COMPREHENSION_3Q_SA ||
          subtype == this.QUE_TYPES.TC_3Q_SA
        ) {
          this.subQuestionLength = 3;
        }
      } else if (
        questionType == this.QUE_TYPES.ASSERTION_REASON ||
        questionType == this.QUE_TYPES.MULTIPLE_CORRECT ||
        questionType == this.QUE_TYPES.SINGLE_CORRECT
      ) {
        answerType = 1; // for questions options
      } else if (
        questionType == this.QUE_TYPES.MATRIX_MATCH_OPTION ||
        questionType == this.QUE_TYPES.MATRIX_MATCH
      ) {
        answerType = 2; // for questions with options, optionsabc, optionspqr
      } else if (
        questionType == this.QUE_TYPES.SUBJECTIVE ||
        questionType == this.QUE_TYPES.SUBJECTIVEINTEGER
      ) {
        answerType = 3; // for subjective type questions
      } else if (questionType == this.QUE_TYPES.INTEGER) {
        answerType = 4; // for integer type questions
      }
      return answerType;
    },

    setDummyAnswerAsPerType(currentQuestion) {
      this.subQuestionLength = 0;
      let answerType = 0;
      let questionType = currentQuestion.questionType.id;
      // check if type is comprehension or tc and set the sub questions length
      answerType = this.getAnswerType(questionType, currentQuestion.subtype);

      let options = null;
      let optionsABC = null;
      let optionsPQR = null;

      switch (answerType) {
        case 0:
          currentQuestion.questions = [];
          for (let i = 0; i < this.subQuestionLength; i++) {
            if (currentQuestion.subtype != this.QUE_TYPES.COMPREHENSION_2Q_NU) {
              currentQuestion.questions.push({
                question_text: this.DUMMYTEXT,
                options: _.cloneDeep(this.dummyOptions),
              });
            } else {
              currentQuestion.questions.push({
                question_text: this.DUMMYTEXT,
                correct_answer: "0##0",
              });
            }
          }
        case 1:
          // options = _.cloneDeep(this.dummyOptions);
          currentQuestion.options = _.cloneDeep(this.dummyOptions);
          currentQuestion.correct_answer = "0";
          break;

        case 2:
          currentQuestion.options =
            questionType == this.QUE_TYPES.MATRIX_MATCH_OPTION
              ? _.cloneDeep(this.dummyOptions)
              : [];
          currentQuestion.options_abc = _.cloneDeep(this.dummyOptionsABC);
          currentQuestion.options_pqr = _.cloneDeep(this.dummyOptionsPQR);
          break;

        case 3:
          // currentQuestion.startValue = "0";
          // currentQuestion.endValue = "0";
          currentQuestion.correct_answer = "0##0";
          break;

        case 4:
          currentQuestion.correct_answer = "0";
          break;

        default:
          break;
      }
      return currentQuestion;
    },
    validate() {
      let isValid = true;
      if (!this.slectedChapter.chapter_id) {
        this.$toasted.error("Please Select Chapter");
        isValid = false;
      }
      if (!this.selectedTopic.topic_id && this.isDBTest) {
        this.$toasted.error("Please Select Topic");
        isValid = false;
      }
      if (!this.selectedDifficultyLevel.id && this.isDBTest) {
        this.$toasted.error("Please Select Difficulty Level");
        isValid = false;
      }
      if (!this.selectedSkillSet.id && this.isDBTest) {
        this.$toasted.error("Please Select skill set");
        isValid = false;
      } //Validity check!
      if (!this.selectedSubTopic.subtopic_id && this.isDBTest) {
        this.$toasted.error("Please Select SubTopic");
        isValid = false;
      }
      if (!this.selectedConcept.concept_id && this.isDBTest) {
        this.$toasted.error("Please Select Concept");
        isValid = false;
      }

      return isValid;
    },
    getTeacherSubjectTree() {
      this.getTeacherSubject()
        .then(response => {
          this.teacherSubjectId = response;
        })
        .catch(err => {});
    },
    getAssignTestStatus() {
      let getData = {
        testId: this.$route.params.test_id,
      };
      //   let me = this;
      //   this.$root.showLoader = true;
      this.assignTestStatus(getData)
        .then(response => {
          //   me.$root.showLoader = false;
          this.AssignedTeacher = response;
        })
        .catch(err => {
          me.$toasted.error("Error getting approval status.");
        });
    },
    getSubTopics(subTopicId) {
      if ((subTopicId || this.selectedTopic.topic_id) && this.isPreview) {
        let reqData = {
          level: 5,
          parent: subTopicId || this.selectedTopic.topic_id,
          target_exam: this.testDetails.target,
          // this.$root.showLoader = true;
        };
        this.subTopics = [];
        this.concepts = [];
        //this.selectedSubTopic = {};
        //this.selectedConcept = {};
        this.getDataTreeWithLevel(reqData)
          .then(response => {
            // this.$root.showLoader = false;
            let subTopicList = [];
            response.map(x => {
              let c = {};
              c.text = x.title;
              c.value = { subtopic_id: x.id, title: x.title };
              subTopicList.push(c);
              //return c;
            });
            this.$forceUpdate();
            this.subTopics = subTopicList;
          })
          .catch(err => {
            // this.$root.showLoader = false;
          });
      }
    },
    getConcepts(conceptId) {
      this.concepts = [];
      if ((conceptId || this.selectedSubTopic.subtopic_id) && this.isPreview) {
        let reqData = {
          level: 6,
          parent: conceptId || this.selectedSubTopic.subtopic_id,
          target_exam: this.testDetails.target,
          // this.$root.showLoader = true;
        };
        //this.selectedConcept = {};
        this.concepts = [];
        this.getDataTreeWithLevel(reqData)
          .then(response => {
            // this.$root.showLoader = false;
            this.concepts = response.map(x => {
              let c = {};
              c.text = x.title;
              c.value = { concept_id: x.id, title: x.title };
              return c;
            });
          })
          .catch(err => {
            // this.$root.showLoader = false;
          });
      }
    },
    getSkillSets(skillsetId) {
      this.skillset = [];
      let reqData = {
        keys: ["ANSWER_TYPE"],
      };
      this.getRefData(reqData)
        .then(response => {
          // this.$root.showLoader = false;
          this.skillset = response.ANSWER_TYPE.map(x => {
            let c = {};
            c.text = x.value;
            c.value = { id: x.id, title: x.value };
            return c;
          });
        })
        .catch(err => {
          // this.$root.showLoader = false;
        });
    },
    onSelectedSubTopic(e) {
      sessionStorage.removeItem("selectedQuestionIds");

      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.subtopic_id = e.subtopic_id;
        this.currentQuestionToBeEdited.subtopicName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.subtopic_id = e.subtopic_id;
        this.currentQuestion.subtopicName = e.title;
      }
      this.getConcepts(e.subtopic_id);
    },
    onSelectedConcept(e) {
      sessionStorage.removeItem("selectedQuestionIds");

      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.concept_id = e.concept_id;
        this.currentQuestionToBeEdited.conceptName = e.title;
      }
      if (this.currentQuestion) {
        this.currentQuestion.concept_id = e.concept_id;
        this.currentQuestion.conceptName = e.title;
      }
    },
    onselectedSkillset(e) {
      sessionStorage.removeItem("selectedQuestionIds");
      if (this.currentQuestionToBeEdited) {
        this.currentQuestionToBeEdited.answer_type = e.id;
        this.currentQuestionToBeEdited.skillsetName = e.value;
      }
      if (this.currentQuestion) {
        this.currentQuestion.answer_type = e.id;
        this.currentQuestion.skillsetName = e.value;
      }
    },
    getQuestionInfo() {
      this.currentQuestion.show_extra_details = false;
      this.currentQuestion.question_view_count= 0;
      this.currentQuestion.last_created_at = null;
      this.currentQuestion.historyDetails = [];
      let reqData = {
        question_id: this.currentQuestion.id,
        test_id: this.testDetails.id,
      };
      this.getQuesDateAndViewCountOfLastCreQues(reqData)
        .then(response => {
          if (response) {
            this.currentQuestion.question_view_count = response.question_view_count;
            this.currentQuestion.last_created_at = response.last_scheduled_date
              ? moment(response.last_scheduled_date).format(
                  constants.DATE_FORMATS.DISPLAY_DATE
                )
              : response.last_created_at
              ? moment(response.last_created_at).format(
                  constants.DATE_FORMATS.DISPLAY_DATE
                )
              : "";
            this.currentQuestion.historyDetails = [];
            response.history_of_question &&
              response.history_of_question.length &&
              response.history_of_question.map(c => {
                this.currentQuestion.historyDetails.push({
                  testScheduleDate: c.last_created_at
                    ? moment(c.last_created_at).format(
                        constants.DATE_FORMATS.DISPLAY_DATE
                      )
                    : "",
                  testCenterName: c.center_name ? c.center_name : "",
                  testBatchName: c.batch_name ? c.batch_name : "",
                });
              });

            this.currentQuestion.lastScheduledBatches = response.last_scheduled_batch_name
              ? response.last_scheduled_batch_name
              : "";
            this.currentQuestion.lastScheduledCenters = response.last_scheduled_center_name
              ? response.last_scheduled_center_name
              : "";
          }
          this.currentQuestion.show_extra_details = true;
          this.$forceUpdate();
        })
        .catch(err => {
          console.log(err);
        });
    },
    openHistoryDialog() {
      this.alertBoxData = {
        question: this.currentQuestion,
      };
      this.modalWidth = "600px";
      this.status = true;
      this.cComponent = "components/student/Tests/PastTests/HistoryDetails";
      this.$forceUpdate();
    },
    openMandatoryQuePopup() {
      this.alertBoxData = {
        mandatoryQueCount: this.questionData.mandatoryQuestions,
        allQuestionCount: this.questionData.questions.length,
      };
      this.alertBoxData.persistent = true;
      this.modalWidth = "420px";
      this.status = true;
      this.cComponent = "components/student/Tests/PastTests/MandatoryQuePopup";
      this.setDisableSecondaryAction(false);
      this.$forceUpdate();
    },
    async tabChanged() {
      console.log("In tabchanged method");
      let noOfTimesTabChanged = "";
      if (sessionStorage.getItem("changedTab")) {
        noOfTimesTabChanged = sessionStorage.getItem("changedTab");
        noOfTimesTabChanged = noOfTimesTabChanged
          ? parseInt(this.decryptString(noOfTimesTabChanged))
          : 0;
      } else {
        noOfTimesTabChanged = await this.getTabCount();
      }
      if (!(typeof noOfTimesTabChanged === "number") || isNaN(noOfTimesTabChanged)) {
        noOfTimesTabChanged = 0;
      }

      noOfTimesTabChanged++;
      let noOfTimesTabChangedUpdated = noOfTimesTabChanged.toString();
      noOfTimesTabChangedUpdated = this.encryptString(noOfTimesTabChangedUpdated);
      let LogData = new Error(
        `user_id: ${this.user.id.toString()}, 
      test_id: ${
        this.testDetails && this.testDetails.id
          ? this.testDetails.id.toString()
          : "Not Found"
      },
      event_name: TAB_CHANGED, 
      counter: ${noOfTimesTabChanged}, 
      time: ${moment().format("YYYY-MM-DD HH:mm:ss.SSS").toString()}`
      );
      let LogDataBe = {
        user_id: this.user.id.toString(),
        test_id:
          this.testDetails && this.testDetails.id
            ? this.testDetails.id.toString()
            : "Not Found",
        event_name: "TAB_CHANGED",
        counter: noOfTimesTabChanged,
        time: moment().format("YYYY-MM-DD HH:mm:ss.SSS").toString(),
        type: "tab-switch",
      };
      sessionStorage.setItem("changedTab", noOfTimesTabChangedUpdated);

      this.logData(LogDataBe);
      if (noOfTimesTabChanged < 3) {
        this.alertBoxData = {
          noOfTimesTabChanged: noOfTimesTabChanged,
          persistent: true,
        };
        this.modalWidth = "400px";
        this.status = true;
        this.cComponent = "components/student/Tests/PastTests/TabSwitchPopup";
        this.$forceUpdate();
      } else {
        this.endAction = this.QUESTION_ACTIONS.END_TEST;
        sessionStorage.setItem("limitCrossed", true);
        this.autoSubmitEndAction = "TabsChanged";
        this.autoSubmitError = "Tabs Changed More Than 2 times";
        this.autoSubmitTestData();
        this.saveCurrentAction("currentQuestion");
      }
      localStorage.removeItem("tabSwitchTime");
      setTimeout(() => {
        this.isTabChanged = false;
      }, 1000);
    },
    async autoSubmitTestData() {
      let noOfTimesTabChanged = sessionStorage.getItem("changedTab");
      noOfTimesTabChanged = noOfTimesTabChanged
        ? parseInt(this.decryptString(noOfTimesTabChanged))
        : 0;

      let reqData = {
        student_id: this.user.id,
        test_id: this.testDetails.id,
        end_action: this.autoSubmitEndAction,
        time_remaining: this.timeObj.asSeconds(),
        end_action: this.autoSubmitEndAction,
        end_action_error: this.autoSubmitError,
        number_of_tabs_changed: noOfTimesTabChanged,
      };
      await this.autoSubmit(reqData);
    },
    openMandatoryQuePopup() {
      this.alertBoxData = {
        mandatoryQueCount: this.questionData.mandatoryQuestions,
        allQuestionCount: this.questionData.questions.length,
      };
      this.alertBoxData.persistent = true;
      this.modalWidth = "420px";
      this.status = true;
      this.cComponent = "components/student/Tests/PastTests/MandatoryQuePopup";
      this.setDisableSecondaryAction(false);
      this.$forceUpdate();
    },
    updateStatus() {
      this.online = navigator.onLine;
      const connection =
        navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    },
    sendRelicError() {
      let error = localStorage.getItem("error_live_test");
      if (error && error != null) {
        let error_log = new Error(error);
        if (error_log && this.online) {
          localStorage.removeItem("error_live_test");
        }
      }
    },
    sendLogData(error, apiname, type, payload) {
      let logData = {
        api: apiname,
        response: error,
        payload: payload,
        network_status: navigator.onLine,
        user_id: this.user.id,
        test_id: this.testDetails ? this.testDetails.id : this.$route.params.test_id,
        type,
      };
      this.logData(logData).catch(err => {
        let logdata = localStorage.getItem("logdata");
        if (logdata) {
          logdata = JSON.parse(logdata);
        } else {
          logdata = [];
        }
        logdata.push(logData);
        localStorage.setItem("logdata", JSON.stringify(logdata));
      });
    },
    sendStoredLogData() {
      let logdata = JSON.parse(localStorage.getItem("logdata"));
      if (logdata && logdata.length) {
        logdata.map(l => this.logData(l));
        localStorage.removeItem("logdata");
      }
    },
    getTabCount() {
      let reqData = {
        user_id: this.user.id,
        test_id: this.testDetails.id,
      };
      return this.getTabChangeCount(reqData)
        .then(res => {
          let noOfTimesTabChanged = res.tab_change_count + "";
          noOfTimesTabChanged = this.encryptString(noOfTimesTabChanged);
          sessionStorage.setItem("changedTab", noOfTimesTabChanged);
          return res.tab_change_count;
        })
        .catch(err => {
          console.log(err);
        });
    },
    setFullScreen() {
      const elem = document.documentElement; // Get the root element of the document
      if (window.innerHeight !== screen.height) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
        } else if (elem.webkitEnterFullscreen) {
          elem.webkitEnterFullscreen(); // For iOS Safari
        } else if (elem.webkitEnterFullScreen) {
          elem.webkitEnterFullScreen(); // For older versions of iOS Safari
        }
      }
    },
    goToQuestion(question, currentQuestionIndex, subject) {
      if (question) {
        let index = this.subjectQuestionTypeList.findIndex(
          s => s.subjectId === subject.id && s.typeId === subject.question_type_id
        );
        let qIndex = this.subjectQuestionTypeList[index].questions.findIndex(
          q => q.id === question.id
        );
        this.showNextQuestion = true;
        this.isUploadAndReplace = false;
        this.isSearchAnotherQ = false;
        this.isCallBucketApi = true;
        this.isSQTChanged = true;
        this.status = false;

        this.nextQuestionIndex = qIndex;
        this.setCurrentQuestionData(index, qIndex);

        this.endAction = this.QUESTION_ACTIONS.JUMP;
        this.scrollQtypeValue = 2;
        this.saveCurrentAction("currentQuestion");
      }
    },
    onPaperCoverage() {
      this.alertBoxData = {
        subjects: this.paperCoverage,
        isPastTest: this.isPastTest,
        isCustom: this.isTestCustom,
        isPreview: this.isPreview,
        goToQuestion: this.goToQuestion,
      };
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent = "components/PreviewTest/PaperCoverage";
      this.$forceUpdate();
    },
    editInstruction() {
      this.cComponent = "components/coordinator/Tests/CustomizedTests/AddInstructions";
      this.modalwidth = "1000px";
      this.status = true;
      this.persistent = false;
      this.$forceUpdate();
    },
    updateInstructions(instructions) {
      let postData = {
        test_id: this.testDetails.id,
        instructions: instructions,
      };
      this.updateTestInstructions(postData)
        .then(response => {
          this.testDetails.instructions = instructions;
          this.instructions = instructions;
          this.$toasted.success("Instructions Updated Successfully");
        })
        .catch(err => {});
    },
  },
};
</script>
